(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.scrolling-banner').forEach(function (banner) {
    if (banner.dataset.animationInitialized === 'true') return;
    banner.dataset.animationInitialized = 'true';

    const textElements = banner.querySelectorAll('.scrolling-text');
    const firstText = textElements[0];
    const secondText = textElements[1];
    if (!firstText || !secondText) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const scrollSpeed = 30;
    let textWidth = 0;
    let firstPosition = 0;
    let secondPosition = 0;
    let lastFrameTime = 0;
    let animationFrame = null;
    let isPaused = reducedMotion.matches;
    const controls = banner.closest('.animated-banner').querySelectorAll('[data-scrolling-banner-control]');

    function updateControls() {
      controls.forEach(function (control) {
        control.dataset.paused = isPaused;
        control.setAttribute('aria-label', isPaused ? 'Play scrolling banner' : 'Pause scrolling banner');
        control.setAttribute('data-click-name', isPaused ? 'Scrolling Banner - Play' : 'Scrolling Banner - Pause');
      });
    }

    function renderPositions() {
      firstText.style.transform = `translate3d(${firstPosition}px, 0, 0)`;
      secondText.style.transform = `translate3d(${secondPosition}px, 0, 0)`;
    }

    function measure() {
      textWidth = firstText.offsetWidth;
      if (!textWidth) return;

      firstPosition = 0;
      secondPosition = textWidth;
      renderPositions();
    }

    function stopAnimation() {
      if (animationFrame !== null) {
        window.cancelAnimationFrame(animationFrame);
        animationFrame = null;
      }
      lastFrameTime = 0;
    }

    function updateScrollPosition(timestamp) {
      if (isPaused || !textWidth) {
        stopAnimation();
        return;
      }

      if (!lastFrameTime) lastFrameTime = timestamp;
      const elapsed = Math.min(timestamp - lastFrameTime, 64);
      const distance = scrollSpeed * elapsed / 1000;
      lastFrameTime = timestamp;

      firstPosition -= distance;
      secondPosition -= distance;

      if (firstPosition <= -textWidth) firstPosition += textWidth * 2;
      if (secondPosition <= -textWidth) secondPosition += textWidth * 2;

      renderPositions();
      animationFrame = window.requestAnimationFrame(updateScrollPosition);
    }

    function startAnimation() {
      if (animationFrame !== null || isPaused) return;
      animationFrame = window.requestAnimationFrame(updateScrollPosition);
    }

    function setPaused(paused) {
      isPaused = paused;
      secondText.hidden = paused;
      secondText.style.display = paused ? 'none' : 'flex';
      if (paused) {
        stopAnimation();
        firstText.style.transform = 'none';
      } else {
        measure();
        startAnimation();
      }
      updateControls();
    }

    measure();
    setPaused(isPaused);

    controls.forEach(function (control) {
      control.addEventListener('click', function () {
        setPaused(!isPaused);
      });
    });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(function () {
        measure();
        startAnimation();
      });
      resizeObserver.observe(firstText);
    } else {
      window.addEventListener('resize', measure, { passive: true });
    }

    function handleReducedMotionChange(event) {
      if (event.matches) setPaused(true);
    }

    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', handleReducedMotionChange);
    } else {
      reducedMotion.addListener(handleReducedMotionChange);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page-section"]) return;
  try {
    
  /* The panel stays in flow while collapsed and is clipped by the item's own
     animated height, which is what `.my-faq-accordion__item`'s height
     transition needs. Toggling `hidden` here would remove it from layout and
     the accordion would snap open instead of animating. */
  const measureFaqItem = (item, panel, withPanel) => {
    const previousHeight = item.style.height;
    const previousTransition = item.style.transition;
    const previousDisplay = panel.style.display;

    item.style.transition = 'none';
    item.style.height = 'auto';
    if (!withPanel) panel.style.display = 'none';

    const height = item.offsetHeight;

    panel.style.display = previousDisplay;
    item.style.height = previousHeight;
    item.style.transition = previousTransition;

    return height;
  };

  const setFaqItemState = (item, trigger, panel, expanded) => {
    item.dataset.open = expanded ? 'true' : 'false';
    trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
    panel.inert = !expanded;
    item.style.height = measureFaqItem(item, panel, expanded) + 'px';
  };

  const initializeFaqAccordions = () => {
    document.querySelectorAll('[data-faq-accordion]').forEach((accordion) => {
      if (accordion.dataset.a11yReady === 'true') return;
      accordion.dataset.a11yReady = 'true';

      const items = Array.from(accordion.querySelectorAll('[data-faq-item]'));

      const eachItem = (callback) => {
        items.forEach((candidate) => {
          const candidateTrigger = candidate.querySelector('[data-faq-trigger]');
          const candidatePanel = candidate.querySelector('[data-faq-panel]');
          if (candidateTrigger && candidatePanel) callback(candidate, candidateTrigger, candidatePanel);
        });
      };

      eachItem((candidate, candidateTrigger, candidatePanel) => {
        setFaqItemState(candidate, candidateTrigger, candidatePanel, candidateTrigger.getAttribute('aria-expanded') === 'true');
      });

      items.forEach((item) => {
        const trigger = item.querySelector('[data-faq-trigger]');
        const panel = item.querySelector('[data-faq-panel]');

        if (!trigger || !panel) return;

        trigger.addEventListener('click', () => {
          const shouldExpand = trigger.getAttribute('aria-expanded') !== 'true';

          eachItem((candidate, candidateTrigger, candidatePanel) => {
            setFaqItemState(candidate, candidateTrigger, candidatePanel, candidate === item && shouldExpand);
          });
        });
      });

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          eachItem((candidate, candidateTrigger, candidatePanel) => {
            candidate.style.height = measureFaqItem(candidate, candidatePanel, candidateTrigger.getAttribute('aria-expanded') === 'true') + 'px';
          });
        }, 150);
      }, { passive: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFaqAccordions);
  } else {
    initializeFaqAccordions();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const initializeFooterCookiePreferences = () => {
    const cookieLinks = document.querySelectorAll('[data-cookie-preferences]');
    
    cookieLinks.forEach(link => {
      const footer = link.closest('footer');
      const status = footer && footer.querySelector('[data-footer-privacy-status]');

      const announce = (message) => {
        if (!status) return;
        status.textContent = '';
        window.setTimeout(() => {
          status.textContent = message;
        }, 0);
      };

      link.addEventListener('click', (e) => {
        e.preventDefault();
        
        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
          window.privacyBanner.showPreferences().catch((error) => {
            console.error('Failed to open cookie preferences:', error);
            announce('Cookie preferences are unavailable. Please try again later.');
          });
        } else if (window.Shopify && window.Shopify.customerPrivacy) {
          announce('Cookie preferences are unavailable. Please try again later.');
        } else {
          console.warn('Cookie consent system not available. Please ensure privacy settings are configured in Shopify admin.');
          announce('Cookie preferences are unavailable. Please try again later.');
        }
      });
    });
  };

  const initializeFooterControls = () => {
    initializeFooterCookiePreferences();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFooterControls);
  } else {
    initializeFooterControls();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["free-samples"]) return;
  try {
    
(function() {
  'use strict';

  var FREE_SAMPLES_DEBUG = false;
  function log() {
    if (FREE_SAMPLES_DEBUG) console.log.apply(console, ['[FreeSamples]'].concat(Array.prototype.slice.call(arguments)));
  }
  function logError() {
    console.error.apply(console, ['[FreeSamples]'].concat(Array.prototype.slice.call(arguments)));
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function(character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  /**
   * FreeSamplesManager - Handles Free Samples logic
   * Subscribes to YISECartData for cart updates
   * Works independently like GWP Manager
   */
  var FreeSamplesManager = {
    config: null,
    isProcessing: false,
    processQueue: null,
    skipNextProcess: false,
    previousSampleKeys: {},
    lastEventType: null,
    addingProductId: null,
    swiperInstance: null,
    unsubscribe: null,
    initialStateCaptured: false,
    initialized: false,

    init: function() {
      if (this.initialized) {
        log('FreeSamplesManager already initialized');
        return;
      }
      this.initialized = true;

      var dataEl = document.querySelector('[data-free-samples-config]');
      if (!dataEl) {
        log('No free-samples-data element found');
        return;
      }

      try {
        this.config = JSON.parse(dataEl.textContent);
        log('Free samples config loaded:', this.config);
      } catch (e) {
        logError('Failed to parse free samples data:', e);
        return;
      }

      if (!this.config) {
        log('No config found');
        return;
      }

      // If not active, clean up any existing free samples and exit.
      // hasFreeSampleLineItem is rendered from Liquid so an inactive feature with
      // nothing to clean never forces the lazy cart controller (cart-full.js) to load.
      if (!this.config.active) {
        if (!this.config.hasFreeSampleLineItem) {
          log('Free samples not active and none in cart - skipping cleanup');
          return;
        }
        log('Free samples not active - checking for cleanup');
        this.cleanupInactiveSamples();
        return;
      }

      if (!this.config.tiers || this.config.tiers.length === 0) {
        log('No free sample tiers configured');
        return;
      }

      // Sort tiers by minimum price ascending
      this.config.tiers.sort(function(a, b) {
        return a.minimumPrice - b.minimumPrice;
      });

      this.subscribeToCart();
      this.renderWidget();
      log('FreeSamplesManager initialized');
    },

    /**
     * Clean up free samples when feature is inactive
     * Fetches cart once and removes any free sample items
     */
    cleanupInactiveSamples: function() {
      var self = this;
      
      // Wait for YISECartData to be available
      if (!window.YISECartData) {
        log('YISECartData not available yet for cleanup, waiting...');
        setTimeout(function() {
          self.cleanupInactiveSamples();
        }, 100);
        return;
      }
      
      // Get cart and check for free samples to remove
      window.YISECartData.get().then(function(cart) {
        var samplesToRemove = [];
        
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if (item.properties && item.properties['_gwp-free-sample'] === 'true') {
            samplesToRemove.push(item.key);
            log('Found inactive free sample to remove:', item.product_title);
          }
        }
        
        if (samplesToRemove.length > 0) {
          log('Removing', samplesToRemove.length, 'free samples (feature inactive)');
          self.removeSamplesAndRefresh(samplesToRemove);
        } else {
          log('No free samples to clean up');
        }
      }).catch(function(error) {
        logError('Error getting cart for cleanup:', error);
      });
    },

    /**
     * Remove samples and refresh cart UI (used for cleanup)
     */
    removeSamplesAndRefresh: function(keys) {
      var self = this;
      var updates = {};
      
      for (var i = 0; i < keys.length; i++) {
        updates[keys[i]] = 0;
      }
      
      return fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-Free-Samples-Request': 'true'
        },
        body: JSON.stringify({ updates: updates })
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        log('Inactive free samples removed successfully');
        // Refresh cart UI
        if (window.YISECartData) {
          window.YISECartData.refresh('free-samples-cleanup');
        }
        self.announceCartStatus('Free samples are no longer available and have been removed from your cart.', false);
      })
      .catch(function(error) {
        logError('Error removing inactive samples:', error);
        self.announceCartStatus('Unable to update free samples. Try again.', true);
      });
    },

    /**
     * Subscribe to YISECartData for cart updates
     */
    subscribeToCart: function() {
      var self = this;
      
      // Wait for YISECartData to be available
      if (!window.YISECartData) {
        log('YISECartData not available yet, waiting...');
        setTimeout(function() {
          self.subscribeToCart();
        }, 100);
        return;
      }
      
      // Subscribe to cart updates - will receive cached cart immediately if available
      // or will receive cart when fetch completes
      this.unsubscribe = window.YISECartData.subscribe('FreeSamplesManager', function(cart, eventType) {
        log('Cart update received, event:', eventType);
        
        // Skip automatic processing if this is our own update
        // But still sync state and update widget to clear loading states
        if (self.skipNextProcess) {
          log('Skipping processing (self-initiated), syncing state only');
          self.skipNextProcess = false;
          self.syncStateOnly(cart);
          return;
        }
        
        // Handle initial cart data (first load)
        // vue-refresh on first load is our initial data
        if (!self.initialStateCaptured) {
          log('Initial cart data received');
          self.captureInitialState(cart);
          self.initialStateCaptured = true;
          return;
        }
        
        // Skip cached events after initial capture
        if (eventType === 'cached' || eventType === 'initial') {
          return;
        }
        
        // Track event type
        if (eventType === 'add' || eventType === 'cart:add') {
          self.lastEventType = 'add';
        } else {
          self.lastEventType = 'update';
        }
        
        // Debounce processing for cart changes, passing event type
        self.debounceProcess(cart, eventType);
      });
      
      log('Subscribed to YISECartData');
    },

    captureInitialState: function(cart) {
      var self = this;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (item.properties && item.properties['_gwp-free-sample'] === 'true') {
          self.previousSampleKeys[item.product_id] = item.key;
          log('Initial free sample tracked:', item.product_title);
        }
      }
      log('Initial state captured:', Object.keys(self.previousSampleKeys).length, 'samples');
      
      // Use setTimeout to defer widget update until AFTER Vue's reactive render cycle
      // Vue uses microtasks (Promise.then) for reactive updates, so a macrotask (setTimeout)
      // ensures we run after Vue has finished re-rendering the cart template
      setTimeout(function() {
        // Process to sync state (initial load, not a user action)
        self.evaluateSamples(cart, 'initial');
        // Wait for Vue to render the cart template before updating widget
        self.waitForWidgetAndUpdate();
      }, 0);
    },
    
    /**
     * Wait for the widget container to exist in DOM, then update
     */
    waitForWidgetAndUpdate: function() {
      var self = this;
      var container = document.getElementById('free-samples-widget');
      
      if (container) {
        self.updateWidget();
      } else {
        // Widget not rendered yet, wait and retry
        log('Widget container not found, waiting...');
        setTimeout(function() {
          self.waitForWidgetAndUpdate();
        }, 100);
      }
    },

    /**
     * Sync internal state with cart without triggering automatic add/remove
     * Used when skipping our own cart updates to keep state in sync
     */
    syncStateOnly: function(cart) {
      var subtotal = this.calculateEligibleSubtotal(cart);
      var reachedTiers = this.getReachedTiers(subtotal);
      var allowedCount = this.getAllowedCount(reachedTiers);
      var samplesInCart = this.findSamplesInCart(cart);
      var currentSampleKeys = {};
      
      // Build current sample keys from cart
      for (var i = 0; i < samplesInCart.length; i++) {
        currentSampleKeys[samplesInCart[i].product_id] = samplesInCart[i].key;
      }
      
      // Sync previousSampleKeys with actual cart state
      this.previousSampleKeys = currentSampleKeys;
      
      // Update lastState so widget and future operations have accurate data
      this.lastState = {
        subtotal: subtotal,
        reachedTiers: reachedTiers,
        allowedCount: allowedCount,
        samplesInCart: samplesInCart,
        availableProducts: this.getAvailableProducts(reachedTiers)
      };
      
      // Clear any adding state and update widget
      this.addingProductId = null;
      this.updateWidget();
      
      log('State synced: ' + samplesInCart.length + '/' + allowedCount + ' samples');
    },

    debounceProcess: function(cart, eventType) {
      var self = this;
      if (this.processQueue) {
        clearTimeout(this.processQueue);
      }
      // Use debounce to let other systems settle first
      this.processQueue = setTimeout(function() {
        if (cart) {
          self.processCartData(cart, eventType);
        } else {
          self.processCart();
        }
      }, 300);
    },

    /**
     * Check if a cart item is a gift card
     */
    isGiftCardItem: function(item) {
      if (item.gift_card) return true;
      
      if (item.product_type) {
        var pt = item.product_type.toLowerCase();
        if (pt === 'gift card' || pt === 'gift cards' || pt.indexOf('gift card') !== -1) {
          return true;
        }
      }
      
      if (item.product_title) {
        if (item.product_title.toLowerCase().indexOf('gift card') !== -1) {
          return true;
        }
      }
      
      if (item.title) {
        if (item.title.toLowerCase().indexOf('gift card') !== -1) {
          return true;
        }
      }
      
      return false;
    },

    /**
     * Calculate eligible subtotal (excluding free samples and optionally gift cards)
     */
    calculateEligibleSubtotal: function(cart) {
      var self = this;
      var subtotal = 0;
      
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        
        // Skip free sample items
        if (item.properties && item.properties['_gwp-free-sample'] === 'true') {
          continue;
        }
        
        // Skip gift cards if configured
        if (this.config.excludeGiftCards && this.isGiftCardItem(item)) {
          continue;
        }
        
        subtotal += (item.original_price || item.price) * item.quantity;
      }
      
      return subtotal / 100; // Convert to dollars
    },

    /**
     * Get reached tiers based on cart subtotal
     */
    getReachedTiers: function(subtotalDollars) {
      var reached = [];
      
      for (var i = 0; i < this.config.tiers.length; i++) {
        var tier = this.config.tiers[i];
        if (subtotalDollars >= tier.minimumPrice) {
          reached.push(tier);
        }
      }
      
      return reached;
    },

    /**
     * Get total allowed samples from reached tiers
     */
    getAllowedCount: function(reachedTiers) {
      var total = 0;
      for (var i = 0; i < reachedTiers.length; i++) {
        total += reachedTiers[i].quantity || 0;
      }
      return total;
    },

    /**
     * Get available products from reached tiers
     */
    getAvailableProducts: function(reachedTiers) {
      var products = [];
      var seenIds = {};
      
      for (var i = 0; i < reachedTiers.length; i++) {
        var tier = reachedTiers[i];
        if (tier.products) {
          for (var j = 0; j < tier.products.length; j++) {
            var product = tier.products[j];
            if (product && product.id && !seenIds[product.id] && product.available) {
              seenIds[product.id] = true;
              products.push(product);
            }
          }
        }
      }
      
      return products;
    },

    /**
     * Find free samples currently in cart
     */
    findSamplesInCart: function(cart) {
      var samples = [];
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (item.properties && item.properties['_gwp-free-sample'] === 'true') {
          samples.push(item);
        }
      }
      return samples;
    },

    /**
     * Main cart processing logic - fetches cart if not provided
     */
    processCart: function() {
      var self = this;
      
      if (this.isProcessing) {
        log('Already processing, queuing...');
        this.debounceProcess();
        return;
      }

      // Use YISECartData to get cart
      if (window.YISECartData) {
        window.YISECartData.get().then(function(cart) {
          self.processCartData(cart);
        }).catch(function(error) {
          logError('Error getting cart:', error);
        });
      }
    },
    
    /**
     * Process cart data directly (when already have cart data from subscriber)
     * @param {Object} cart - Cart data
     * @param {string} eventType - Type of event that triggered this update
     */
    processCartData: function(cart, eventType) {
      if (this.isProcessing) {
        log('Already processing, queuing...');
        this.debounceProcess(cart, eventType);
        return;
      }

      var self = this;
      this.isProcessing = true;

      try {
        log('Processing cart data, event:', eventType);
        this.evaluateSamples(cart, eventType);
      } catch (error) {
        logError('Error processing cart:', error);
      } finally {
        this.isProcessing = false;
        this.updateWidget();
      }
    },

    /**
     * Evaluate and sync free samples with cart state
     * @param {Object} cart - Cart data
     * @param {string} eventType - Type of event that triggered this update
     */
    evaluateSamples: function(cart, eventType) {
      var self = this;
      var subtotal = this.calculateEligibleSubtotal(cart);
      var reachedTiers = this.getReachedTiers(subtotal);
      var allowedCount = this.getAllowedCount(reachedTiers);
      var samplesInCart = this.findSamplesInCart(cart);
      var currentSampleKeys = {};

      log('Subtotal: $' + subtotal + ', Allowed: ' + allowedCount + ', In cart: ' + samplesInCart.length);

      // Track current samples
      for (var i = 0; i < samplesInCart.length; i++) {
        currentSampleKeys[samplesInCart[i].product_id] = samplesInCart[i].key;
      }

      // Update previous keys
      this.previousSampleKeys = currentSampleKeys;

      // Remove excess samples if over limit
      if (samplesInCart.length > allowedCount) {
        var excess = samplesInCart.length - allowedCount;
        var toRemove = [];
        
        // Remove from the beginning (oldest first)
        for (var j = 0; j < excess; j++) {
          toRemove.push(samplesInCart[j].key);
          log('Will remove excess sample:', samplesInCart[j].product_title);
        }
        
        if (toRemove.length > 0) {
          return this.removeSamples(toRemove, 'Removed free samples because your cart no longer qualifies for them.');
        }
      }

      // Remove all samples if no longer qualifies for any tier
      if (reachedTiers.length === 0 && samplesInCart.length > 0) {
        var keysToRemove = [];
        for (var k = 0; k < samplesInCart.length; k++) {
          keysToRemove.push(samplesInCart[k].key);
        }
        log('No longer qualifies - removing all', keysToRemove.length, 'samples');
        return this.removeSamples(keysToRemove, 'Removed free samples because your cart no longer qualifies for them.');
      }

      // Store state for widget
      this.lastState = {
        subtotal: subtotal,
        reachedTiers: reachedTiers,
        allowedCount: allowedCount,
        samplesInCart: samplesInCart,
        availableProducts: this.getAvailableProducts(reachedTiers)
      };

      return Promise.resolve();
    },

    /**
     * Remove samples from cart
     */
    removeSamples: function(keys, statusMessage) {
      var self = this;
      var updates = {};
      
      for (var i = 0; i < keys.length; i++) {
        updates[keys[i]] = 0;
      }
      
      log('Removing samples:', keys);
      
      return fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-Free-Samples-Request': 'true'
        },
        body: JSON.stringify({ updates: updates })
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        log('Samples removed successfully');
        self.refreshCartUI();
        if (statusMessage) self.announceCartStatus(statusMessage, false);
      })
      .catch(function(error) {
        logError('Error removing samples:', error);
        self.announceCartStatus('Unable to update free samples. Try again.', true);
      });
    },

    /**
     * Add a free sample to cart (called from UI)
     */
    addSample: function(product) {
      var self = this;
      
      // Save scroll position IMMEDIATELY before any async operations
      // This preserves scroll from bottom so user stays in same position after item is added
      // No scroll preservation here; cart handles its own scroll logic
      
      if (!product || !product.variantId) {
        logError('Invalid product - no variantId');
        return Promise.reject('Invalid product');
      }

      // Check if already in cart
      if (this.lastState && this.lastState.samplesInCart) {
        for (var i = 0; i < this.lastState.samplesInCart.length; i++) {
          if (this.lastState.samplesInCart[i].product_id === product.id) {
            log('Sample already in cart');
            return Promise.reject('Already in cart');
          }
        }
      }

      // Check if at limit
      if (this.lastState && this.lastState.samplesInCart.length >= this.lastState.allowedCount) {
        log('Already at sample limit');
        return Promise.reject('At limit');
      }

      log('Adding sample:', product.title);
      this.addingProductId = product.id;
      this.updateWidget();

      var formData = {
        items: [{
          id: product.variantId,
          quantity: 1,
          properties: {
            '_gwp': 'true',
            '_gwp-free-sample': 'true',
            '_promoTitle': 'Free Sample'
          }
        }]
      };

      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-Free-Samples-Request': 'true'
        },
        body: JSON.stringify(formData)
      })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(data) {
            return Promise.reject((data && (data.description || data.message)) || 'Unable to add free sample');
          });
        }
        return response.json();
      })
      .then(function(data) {
        log('Sample added successfully:', data);
        self.addingProductId = null;
        
        // Track this sample
        if (data.items && data.items.length > 0) {
          self.previousSampleKeys[product.id] = data.items[0].key;
        }
        
        // Dispatch event for cart UI
        document.dispatchEvent(new CustomEvent('cart:add', {
          bubbles: true,
          detail: { items: data.items, source: 'free-samples-manager' }
        }));
        
        self.refreshCartUI();
        return data;
      })
      .catch(function(error) {
        logError('Error adding sample:', error);
        self.addingProductId = null;
        self.updateWidget();
        self.announceCartStatus('Unable to add ' + product.title + ' as a free sample. Try again.', true);
        throw error;
      });
    },

    announceCartStatus: function(message, isError) {
      if (window.miniCart && typeof window.miniCart.announceCartStatus === 'function') {
        window.miniCart.announceCartStatus(message, isError);
      }
    },

    refreshCartUI: function() {
      this.skipNextProcess = true;
      // Use YISECartData to refresh - this will notify all subscribers including miniCart
      if (window.YISECartData) {
        window.YISECartData.refresh('free-samples-update');
      }
    },

    /**
     * Render the widget container (actual content updated dynamically)
     */
    renderWidget: function() {
      // Widget is rendered in cart-template.liquid, we just need to update it
      this.lastState = null;
    },

    /**
     * Update widget UI based on current state
     */
    updateWidget: function() {
      var container = document.getElementById('free-samples-widget');
      if (!container) {
        log('Widget container not found');
        return;
      }

      var state = this.lastState;
      if (!state || !state.reachedTiers || state.reachedTiers.length === 0) {
        log('No state or no reached tiers - hiding widget');
        container.style.display = 'none';
        return;
      }

      if (state.availableProducts.length === 0) {
        log('No available products - hiding widget');
        container.style.display = 'none';
        return;
      }

      log('Updating widget with', state.availableProducts.length, 'products');
      container.style.display = 'block';
      
      // Update title
      var titleEl = container.querySelector('.yise-cart__free-samples-title');
      if (titleEl && this.config.heading) {
        titleEl.textContent = this.config.heading;
      }

      // Update count
      var countEl = container.querySelector('.yise-cart__free-samples-count');
      if (countEl) {
        countEl.textContent = state.samplesInCart.length + '/' + state.allowedCount;
      }

      // Update message
      var messageEl = container.querySelector('.yise-cart__free-samples-message');
      if (messageEl) {
        var highestTier = state.reachedTiers[state.reachedTiers.length - 1];
        if (highestTier && highestTier.message) {
          messageEl.innerHTML = highestTier.message;
          messageEl.style.display = 'block';
        } else {
          messageEl.style.display = 'none';
        }
      }

      // Build products in cart lookup
      var inCartIds = {};
      for (var i = 0; i < state.samplesInCart.length; i++) {
        inCartIds[state.samplesInCart[i].product_id] = true;
      }

      // Update products list (as swiper slides)
      var productsContainer = container.querySelector('.yise-cart__free-samples-products');
      if (productsContainer) {
        var html = '';
        var self = this;
        var activeElement = document.activeElement;
        var focusedProductId = activeElement && activeElement.classList.contains('yise-cart__free-samples-add-btn')
          ? activeElement.getAttribute('data-product-id')
          : null;
        
        for (var j = 0; j < state.availableProducts.length; j++) {
          var product = state.availableProducts[j];
          var isInCart = inCartIds[product.id];
          var isAdding = this.addingProductId === product.id;
          var atLimit = state.samplesInCart.length >= state.allowedCount;
          var isDisabled = isInCart || isAdding || atLimit;
          var productTitle = escapeHtml(product.title);
          var productVariant = escapeHtml(product.variantTitle);
          var imageAlt = escapeHtml(product.featuredImageAlt);
          var buttonLabel = 'Add ' + product.title + ' as a free sample';

          if (isAdding) {
            buttonLabel = 'Adding ' + product.title + ' as a free sample';
          } else if (isInCart) {
            buttonLabel = 'Added ' + product.title + ' as a free sample';
          } else if (atLimit) {
            buttonLabel = 'Add ' + product.title + ' as a free sample, sample limit reached';
          }
          
          html += '<div class="swiper-slide yise-cart__free-samples-slide">';
          html += '  <div class="yise-cart__free-samples-product" data-product-id="' + product.id + '">';
          html += '    <div class="yise-cart__free-samples-product-image">';
          html += '      <img src="' + escapeHtml(product.featuredImage) + '" alt="' + imageAlt + '" width="100" height="100" loading="lazy" />';
          html += '    </div>';
          html += '    <div class="yise-cart__free-samples-product-info">';
          html += '      <span class="yise-cart__free-samples-product-title">' + productTitle + '</span>';
          if (product.variantTitle && product.variantTitle !== 'Default Title') {
            html += '      <span class="yise-cart__free-samples-product-variant">' + productVariant + '</span>';
          }
          html += '    </div>';
          html += '    <button type="button" class="button mini yise-cart__free-samples-add-btn' + (isInCart ? ' yise-cart__free-samples-add-btn--added' : '') + '"';
          html += '      data-variant-id="' + product.variantId + '"';
          html += '      data-product-id="' + product.id + '"';
          html += '      data-click-name="Free Sample - Add"';
          html += '      aria-label="' + escapeHtml(buttonLabel) + '"';
          html += '      aria-disabled="' + (isDisabled ? 'true' : 'false') + '"';
          if (isAdding) html += ' aria-busy="true"';
          html += '    >';
          if (isAdding) {
            html += '<span class="yise-cart__loader yise-cart__loader--small" aria-hidden="true"></span>';
          } else if (isInCart) {
            html += 'Added';
          } else {
            html += 'Add';
          }
          html += '</button>';
          html += '  </div>';
          html += '</div>';
        }
        
        productsContainer.innerHTML = html;
        
        // Attach click handlers
        var buttons = productsContainer.querySelectorAll('.yise-cart__free-samples-add-btn');
        buttons.forEach(function(btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            if (btn.getAttribute('aria-disabled') === 'true') return;
            var productId = parseInt(btn.getAttribute('data-product-id'));
            var product = null;
            for (var k = 0; k < state.availableProducts.length; k++) {
              if (state.availableProducts[k].id === productId) {
                product = state.availableProducts[k];
                break;
              }
            }
            if (product) {
              self.addSample(product);
            }
          });
        });
        
        // Initialize or reinitialize Swiper
        this.initSwiper();

        if (focusedProductId) {
          var restoredFocus = productsContainer.querySelector('.yise-cart__free-samples-add-btn[data-product-id="' + focusedProductId + '"]');
          if (restoredFocus) restoredFocus.focus();
        }
      }
    },
    
    syncSwiperAccessibility: function(swiper) {
      if (!swiper || !swiper.el) return;

      var carouselId = 'FreeSamplesCarousel-' + (this.config.sectionId || 'widget');
      var totalSlides = swiper.slides.length;
      var previousButton = swiper.navigation && swiper.navigation.prevEl;
      var nextButton = swiper.navigation && swiper.navigation.nextEl;

      swiper.el.id = carouselId;
      swiper.el.setAttribute('role', 'region');
      swiper.el.setAttribute('aria-roledescription', 'carousel');
      swiper.el.setAttribute('aria-label', this.config.heading || 'Free samples');

      if (previousButton) {
        previousButton.setAttribute('aria-controls', carouselId);
        previousButton.setAttribute('aria-disabled', swiper.isBeginning || swiper.isLocked ? 'true' : 'false');
      }

      if (nextButton) {
        nextButton.setAttribute('aria-controls', carouselId);
        nextButton.setAttribute('aria-disabled', swiper.isEnd || swiper.isLocked ? 'true' : 'false');
      }

      Array.from(swiper.pagination.bullets || []).forEach(function(bullet, index) {
        var isCurrent = index === swiper.snapIndex;
        bullet.setAttribute('aria-controls', carouselId);
        bullet.setAttribute('aria-pressed', isCurrent ? 'true' : 'false');
        bullet.setAttribute('aria-label', 'Show free sample ' + (index + 1) + ' of ' + totalSlides);
      });

      Array.from(swiper.slides).forEach(function(slide) {
        var isVisible = slide.classList.contains('swiper-slide-visible');
        slide.inert = !isVisible;
        slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      });
    },

    /**
     * Initialize or reinitialize the Swiper for free samples
     * Preserves the current slide position when reinitializing
     */
    initSwiper: function() {
      var self = this;
      var swiperEl = document.querySelector('.js-free-samples-swiper');
      
      if (!swiperEl) {
        log('No swiper element found');
        return;
      }
      
      // Save current slide index before destroying
      var currentSlideIndex = 0;
      if (this.swiperInstance && typeof this.swiperInstance.activeIndex !== 'undefined') {
        currentSlideIndex = this.swiperInstance.activeIndex;
        log('Saving current slide index:', currentSlideIndex);
      }
      
      // Destroy existing swiper if present
      if (this.swiperInstance && typeof this.swiperInstance.destroy === 'function') {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
      
      // Check if Swiper is available
      if (typeof Swiper === 'undefined') {
        log('Swiper not available');
        return;
      }
      
      this.swiperInstance = new Swiper('.js-free-samples-swiper', {
        grabCursor: true,
        spaceBetween: 12,
        threshold: 10,
        cssMode: false,
        touchAngle: 75,
        touchMoveStopPropagation: true,
        slidesPerView: 'auto',
        centeredSlides: false,
        slideToClickedSlide: false,
        passiveListeners: true,
        shortSwipes: true,
        initialSlide: currentSlideIndex,
        watchSlidesProgress: true,
        a11y: {
          containerMessage: this.config.heading || 'Free samples',
          containerRoleDescriptionMessage: 'carousel',
          slideLabelMessage: 'Free sample \u007b\u007bindex\u007d\u007d of \u007b\u007bslidesLength\u007d\u007d',
          prevSlideMessage: 'Previous free samples',
          nextSlideMessage: 'Next free samples',
          paginationBulletMessage: 'Show free sample \u007b\u007bindex\u007d\u007d'
        },
        navigation: {
          prevEl: '.free-samples-swiper-prev',
          nextEl: '.free-samples-swiper-next'
        },
        pagination: {
          el: '.free-samples-pagination',
          type: 'bullets',
          clickable: true,
          renderBullet: function(index, className) {
            return '<button type="button" class="' + className + '" aria-label="Show free sample ' + (index + 1) + '"></button>';
          }
        },
        on: {
          init: function(swiper) {
            self.syncSwiperAccessibility(swiper);
          },
          slideChange: function(swiper) {
            self.syncSwiperAccessibility(swiper);
          },
          resize: function(swiper) {
            self.syncSwiperAccessibility(swiper);
          },
          update: function(swiper) {
            self.syncSwiperAccessibility(swiper);
          }
        }
      });
      
      log('Swiper initialized at slide', currentSlideIndex);
    }
  };

  function scheduleFreeSamplesInit() {
    var init = function() {
      FreeSamplesManager.init();
    };

    var deferInit = function() {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(init, { timeout: 2500 });
      } else {
        setTimeout(init, 1200);
      }
    };

    if (document.readyState === 'complete') {
      deferInit();
    } else {
      window.addEventListener('load', deferInit, { once: true });
    }
  }

  scheduleFreeSamplesInit();

  // Expose globally for debugging and external access
  window.FreeSamplesManager = FreeSamplesManager;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["friends-of-yise"] && !Shopify.designMode) return;
  try {
    
  class FriendsOfYise extends HTMLElement {
    connectedCallback() {
      this.connectionController?.abort();
      this.connectionController = new AbortController();
      const { signal } = this.connectionController;
      this.cards = Array.from(this.querySelectorAll('.friends-card'));
      this.panels = Array.from(this.querySelectorAll('.friends-panel'));
      this.swipers = {};
      this.activeId = null;
      this.isEditor = !!(window.Shopify && window.Shopify.designMode);
      this.urlParam = this.dataset.urlParam || 'person';
      this.reduceMotion = window.matchMedia
        ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
        : false;

      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);

      this.cards.forEach((card) => card.addEventListener('click', this.handleClick, { signal }));
      this.addEventListener('keydown', this.handleKeydown, { signal });

      if (this.isEditor) {
        document.addEventListener('shopify:block:select', this.handleBlockSelect, { signal });
      }

      this.initRotationSwipers();

      // Initial selection priority: URL param > server-active card > first card.
      const fromUrl = this.cardFromUrl();
      const initial =
        fromUrl ||
        this.cards.find((card) => card.classList.contains('is-active')) ||
        this.cards[0];

      if (initial) {
        this.activate(initial.dataset.friendId, { animate: false, updateUrl: false });
        if (fromUrl && !this.isEditor) {
          // Preselected via URL — reveal the detail section past the persona grid.
          requestAnimationFrame(() => {
            if (!signal.aborted && this.isConnected) this.scrollToDetail('smooth');
          });
        }
      }
    }

    disconnectedCallback() {
      this.connectionController?.abort();
      window.clearTimeout(this.swiperBuildTimer);
      this.cards.forEach((card) => card.removeEventListener('click', this.handleClick));
      this.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      Object.keys(this.swipers).forEach((id) => {
        if (this.swipers[id] && typeof this.swipers[id].destroy === 'function') {
          this.swipers[id].destroy(true, true);
        }
      });
      this.querySelectorAll('.friends-rotation_swiper').forEach((el) => {
        delete el.dataset.swiperReady;
      });
      this.swipers = {};
    }

    initRotationSwipers() {
      const swiperEls = Array.from(this.querySelectorAll('.friends-rotation_swiper'));
      if (!swiperEls.length) return;

      const { signal } = this.connectionController;
      const build = () => {
        if (signal.aborted || !this.isConnected) return;
        if (typeof Swiper === 'undefined') {
          this.swiperBuildTimer = window.setTimeout(build, 120);
          return;
        }
        swiperEls.forEach((el) => {
          if (el.dataset.swiperReady === 'true') return;
          const wrap = el.closest('.friends-rotation_swiper-wrap');
          const previousButton = wrap.querySelector('.js-friends-rotation-prev');
          const nextButton = wrap.querySelector('.js-friends-rotation-next');
          const instance = new Swiper(el, {
            slidesPerView: 1.25,
            spaceBetween: 16,
            loop: false,
            centerInsufficientSlides: true,
            watchOverflow: true,
            watchSlidesProgress: true,
            observer: true,
            observeParents: true,
            threshold: 8,
            a11y: {
              containerMessage: el.getAttribute('aria-label'),
              containerRoleDescriptionMessage: 'carousel',
              prevSlideMessage: previousButton.getAttribute('aria-label'),
              nextSlideMessage: nextButton.getAttribute('aria-label')
            },
            navigation: {
              nextEl: nextButton,
              prevEl: previousButton
            },
            on: {
              init: (swiper) => this.syncRotationSwiperAccessibility(swiper),
              slideChange: (swiper) => this.syncRotationSwiperAccessibility(swiper),
              resize: (swiper) => this.syncRotationSwiperAccessibility(swiper),
              update: (swiper) => this.syncRotationSwiperAccessibility(swiper)
            },
            breakpoints: {
              768: { slidesPerView: 3, spaceBetween: 24 }
            }
          });
          el.dataset.swiperReady = 'true';
          this.swipers[el.dataset.friendId] = instance;
        });
        if (this.activeId && this.swipers[this.activeId]) {
          this.swipers[this.activeId].update();
        }
      };

      build();
    }

    syncRotationSwiperAccessibility(swiper) {
      if (!swiper || !swiper.el) return;

      const wrap = swiper.el.closest('.friends-rotation_swiper-wrap');
      const previousButton = wrap && wrap.querySelector('.js-friends-rotation-prev');
      const nextButton = wrap && wrap.querySelector('.js-friends-rotation-next');

      if (previousButton) {
        previousButton.setAttribute('aria-disabled', swiper.isBeginning || swiper.isLocked ? 'true' : 'false');
      }

      if (nextButton) {
        nextButton.setAttribute('aria-disabled', swiper.isEnd || swiper.isLocked ? 'true' : 'false');
      }

      Array.from(swiper.slides).forEach((slide) => {
        const isVisible = slide.classList.contains('swiper-slide-visible');
        slide.inert = !isVisible;
        slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      });
    }

    cardForId(friendId) {
      return this.cards.find((card) => card.dataset.friendId === friendId) || null;
    }

    cardFromUrl() {
      if (this.isEditor) return null;
      try {
        const value = new URLSearchParams(window.location.search).get(this.urlParam);
        if (!value) return null;
        return this.cards.find((card) => card.dataset.friendSlug === value) || null;
      } catch (err) {
        return null;
      }
    }

    syncUrl(friendId) {
      if (this.isEditor || !window.history || !window.history.replaceState) return;
      const card = this.cardForId(friendId);
      if (!card || !card.dataset.friendSlug) return;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set(this.urlParam, card.dataset.friendSlug);
        window.history.replaceState({}, '', url);
      } catch (err) {
        /* no-op */
      }
    }

    stickyOffset() {
      let bottom = 0;
      const candidates = document.querySelectorAll(
        'header, [class*="header"], [class*="announcement"], [data-sticky]'
      );
      candidates.forEach((el) => {
        const cs = window.getComputedStyle(el);
        if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
        const rect = el.getBoundingClientRect();
        if (rect.top <= 2 && rect.height > 0 && rect.height < window.innerHeight * 0.5) {
          bottom = Math.max(bottom, rect.bottom);
        }
      });
      return bottom;
    }

    focusDetail() {
      const panel = this.querySelector('.friends-meet[data-active="true"]');
      if (!panel || typeof panel.focus !== 'function') return;
      panel.focus({ preventScroll: true });
    }

    scrollToDetail(behavior) {
      const target = this.querySelector('.friends-detail--meet');
      if (!target) return;
      const offset = this.stickyOffset() + 64; // sit 4rem below the sticky header
      const top = window.pageYOffset + target.getBoundingClientRect().top - offset;
      window.scrollTo({ top: Math.max(top, 0), behavior: behavior || 'smooth' });
    }

    animateActivePanels() {
      if (this.reduceMotion) return;
      this.panels.forEach((panel) => {
        if (panel.classList.contains('is-hidden')) return;
        if (typeof panel.animate !== 'function') return;
        panel.animate(
          [
            { opacity: 0, transform: 'translateY(16px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ],
          { duration: 480, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)' }
        );
      });
    }

    handleClick(event) {
      this.activate(event.currentTarget.dataset.friendId, { scroll: true });
    }

    handleKeydown(event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      const index = this.cards.indexOf(document.activeElement);
      if (index === -1) return;
      event.preventDefault();
      const offset = event.key === 'ArrowRight' ? 1 : -1;
      const next = this.cards[(index + offset + this.cards.length) % this.cards.length];
      next.focus();
      this.activate(next.dataset.friendId);
    }

    handleBlockSelect(event) {
      if (event.detail && event.detail.sectionId && event.detail.sectionId !== this.dataset.sectionId) return;
      const id = event.detail ? event.detail.blockId : null;
      if (id && this.cardForId(id)) {
        this.activate(id);
      }
    }

    activate(friendId, options) {
      if (!friendId) return;
      const opts = options || {};
      const animate = opts.animate !== false;
      const updateUrl = opts.updateUrl !== false;
      const scroll = opts.scroll === true;
      const changed = friendId !== this.activeId;
      this.activeId = friendId;

      this.cards.forEach((card) => {
        const isActive = card.dataset.friendId === friendId;
        card.classList.toggle('is-active', isActive);
        card.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.friendId === friendId;
        panel.classList.toggle('is-hidden', !isActive);
        panel.hidden = !isActive;
        if (isActive) {
          panel.setAttribute('data-active', 'true');
        } else {
          panel.removeAttribute('data-active');
        }
      });

      if (this.swipers[friendId] && typeof this.swipers[friendId].update === 'function') {
        const swiper = this.swipers[friendId];
        const { signal } = this.connectionController;
        requestAnimationFrame(() => {
          if (!signal.aborted && this.isConnected && !swiper.destroyed) swiper.update();
        });
      }

      if (animate && changed) this.animateActivePanels();
      if (updateUrl) this.syncUrl(friendId);
      if (scroll) {
        this.focusDetail();
        this.scrollToDetail('smooth');
      }
    }
  }

  if (!customElements.get('friends-of-yise')) {
    customElements.define('friends-of-yise', FriendsOfYise);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-bleed-columns"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '.js-fbc-slider';
    var lastActivatedArrow = null;
    var lastActivatedAt = 0;

    function rememberArrow(event) {
      var button = event.target.closest('.js-fbc-prev, .js-fbc-next');
      if (!button) return;
      lastActivatedArrow = button;
      lastActivatedAt = performance.now();
    }

    document.addEventListener('click', rememberArrow, true);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') rememberArrow(event);
    }, true);

    /* Swiper's a11y module blurs an arrow and strips its tabindex on reaching an edge,
       which loses the focus of the person who just pressed it. */
    function keepArrowsFocusable(previousButton, nextButton) {
      [previousButton, nextButton].forEach(function (button) {
        if (!button) return;
        button.removeAttribute('disabled');
        if (button.getAttribute('tabindex') !== '0') button.setAttribute('tabindex', '0');
      });
    }

    function restoreArrowFocus() {
      if (!lastActivatedArrow) return;
      if (performance.now() - lastActivatedAt > 1000) return;
      if (document.activeElement && document.activeElement !== document.body) return;
      if (!lastActivatedArrow.isConnected) return;
      lastActivatedArrow.focus({ preventScroll: true });
    }

    function syncAccessibility(swiper, previousButton, nextButton) {
      var locked = swiper.isLocked;

      if (previousButton) {
        previousButton.setAttribute('aria-disabled', swiper.isBeginning || locked ? 'true' : 'false');
      }

      if (nextButton) {
        nextButton.setAttribute('aria-disabled', swiper.isEnd || locked ? 'true' : 'false');
      }

      keepArrowsFocusable(previousButton, nextButton);
      requestAnimationFrame(function () {
        keepArrowsFocusable(previousButton, nextButton);
        restoreArrowFocus();
      });

      var stripRect = swiper.el.getBoundingClientRect();

      Array.prototype.forEach.call(swiper.slides, function (slide) {
        var rect = slide.getBoundingClientRect();
        var visible =
          slide.classList.contains('swiper-slide-visible') &&
          rect.left >= stripRect.left - 1 &&
          rect.right <= stripRect.right + 1;
        slide.inert = !visible;
        slide.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });
    }

    function destroy(track) {
      if (!track.swiper) return;
      track.swiper.destroy(true, true);
      Array.prototype.forEach.call(track.querySelectorAll('.fbc_column'), function (slide) {
        slide.inert = false;
        slide.removeAttribute('aria-hidden');
      });
    }

    function build(track) {
      if (typeof Swiper === 'undefined') return;

      if (track.getAttribute('data-layout') !== 'slider') {
        destroy(track);
        return;
      }

      if (track.swiper) {
        track.swiper.update();
        return;
      }

      var viewport = track.closest('.fbc_viewport');
      var previousButton = viewport ? viewport.querySelector('.js-fbc-prev') : null;
      var nextButton = viewport ? viewport.querySelector('.js-fbc-next') : null;
      var arrows = viewport ? viewport.querySelector('.fbc_arrows') : null;
      var label = track.getAttribute('data-carousel-label') || 'Columns';
      var slideCount = track.querySelectorAll('.fbc_column').length;
      var shouldLoop = track.getAttribute('data-loop') === 'true' && slideCount >= 6;

      new Swiper(track, {
        slidesPerView: 'auto',
        spaceBetween: 0,
        speed: 300,
        cssMode: false,
        breakpointsBase: 'container',
        loop: shouldLoop,
        centerInsufficientSlides: true,
        watchOverflow: true,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        passiveListeners: true,
        shortSwipes: true,
        threshold: 10,
        touchAngle: 75,
        touchMoveStopPropagation: true,
        mousewheel: {
          releaseOnEdges: false,
          forceToAxis: true,
          sensitivity: 0.25
        },
        a11y: {
          containerMessage: label,
          containerRoleDescriptionMessage: 'carousel',
          itemRoleDescriptionMessage: 'slide',
          slideRole: 'listitem',
          slideLabelMessage: 'Slide \u007b\u007bindex\u007d\u007d of \u007b\u007bslidesLength\u007d\u007d',
          prevSlideMessage: previousButton ? previousButton.getAttribute('aria-label') : 'Previous slide',
          nextSlideMessage: nextButton ? nextButton.getAttribute('aria-label') : 'Next slide'
        },
        navigation: {
          nextEl: nextButton,
          prevEl: previousButton
        },
        on: {
          init: function (swiper) {
            if (arrows) arrows.hidden = swiper.isLocked;
            syncAccessibility(swiper, previousButton, nextButton);
          },
          slideChange: function (swiper) {
            syncAccessibility(swiper, previousButton, nextButton);
          },
          toEdge: function (swiper) {
            syncAccessibility(swiper, previousButton, nextButton);
          },
          fromEdge: function (swiper) {
            syncAccessibility(swiper, previousButton, nextButton);
          },
          transitionEnd: function (swiper) {
            syncAccessibility(swiper, previousButton, nextButton);
          },
          resize: function (swiper) {
            if (arrows) arrows.hidden = swiper.isLocked;
            syncAccessibility(swiper, previousButton, nextButton);
          },
          update: function (swiper) {
            if (arrows) arrows.hidden = swiper.isLocked;
            syncAccessibility(swiper, previousButton, nextButton);
          }
        }
      });
    }

    function buildAll(root) {
      var scope = root && root.querySelectorAll ? root : document;
      Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), build);
    }

    function init() {
      buildAll(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    window.addEventListener('yise:swiper-ready', init, { once: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(init, 200);
    });

    document.addEventListener('shopify:section:load', function (event) {
      buildAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      Array.prototype.forEach.call(event.target.querySelectorAll(SELECTOR), destroy);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var slide = event.target.closest('.fbc_column');
      if (!slide) return;
      var track = slide.closest(SELECTOR);
      if (!track || !track.swiper) return;
      track.swiper.slideTo(Array.prototype.indexOf.call(track.swiper.slides, slide));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gifts-with-purchase"]) return;
  try {
    
  (function() {
    'use strict';

    var GWP_DEBUG = false;
    function log() {
      if (GWP_DEBUG) console.log.apply(console, ['[GWP]'].concat(Array.prototype.slice.call(arguments)));
    }

    /**
     * GWP Manager - Handles Gift With Purchase logic
     * Subscribes to YISECartData for cart updates
     */
    var GWPManager = {
      gwpData: null,
      isProcessing: false,
      processQueue: null,
      urlParams: {},
      skipNextProcess: false,
      previousGwpKeys: {},
      blockedGwps: {},
      lastEventType: null,
      unsubscribe: null,
      initialStateCaptured: false,
      analyticsState: {},
      analyticsOfferAvailability: {},
      analyticsMutationCounts: {},
      pendingGwpRemovals: [],
      cartMutationPauseKey: 'yise-gwp-cart-mutation-paused-until',
      cartMutationPauseMs: 300000,
      removalReasons: {
        inactiveOffer: { reason: 'inactive_offer' },
        thresholdLost: { reason: 'threshold_lost' },
        duplicatePromo: { reason: 'duplicate_promo' },
        duplicateVariant: { reason: 'duplicate_variant' },
        quantityCorrection: { reason: 'quantity_correction' },
        userRemoved: { reason: 'user_removed' }
      },
      initialized: false,

      init: function() {
        if (this.initialized) {
          log('GWP already initialized');
          return;
        }
        this.initialized = true;

        var dataEl = document.querySelector('[data-gwp-data]');
        if (!dataEl) {
          log('No GWP data element found');
          return;
        }

        try {
          this.gwpData = JSON.parse(dataEl.textContent);
          log('GWP data loaded:', this.gwpData);
        } catch (e) {
          console.error('[GWP] Failed to parse GWP data:', e);
          return;
        }

        if (!this.gwpData || !this.gwpData.blocks || this.gwpData.blocks.length === 0) {
          log('No active GWP blocks');
          return;
        }

        this.parseUrlParams();
        this.subscribeToCart();
        log('GWP initialized');
      },

      /**
       * Subscribe to YISECartData for cart updates
       */
      subscribeToCart: function() {
        var self = this;
        
        // Wait for YISECartData to be available
        if (!window.YISECartData) {
          log('YISECartData not available yet, waiting...');
          setTimeout(function() {
            self.subscribeToCart();
          }, 100);
          return;
        }
        
        // Subscribe to cart updates - will receive cached cart immediately if available
        // or will receive cart when fetch completes
        this.unsubscribe = window.YISECartData.subscribe('GWPManager', function(cart, eventType) {
          log('Cart update received, event:', eventType);
          
          // Skip if this is our own update
          if (self.skipNextProcess) {
            log('Skipping (self-initiated)');
            self.skipNextProcess = false;
            return;
          }
          
          // Handle initial cart data (first load)
          // vue-refresh on first load is our initial data
          if (!self.initialStateCaptured) {
            log('Initial cart data received');
            self.captureInitialGwpState(cart);
            self.initialStateCaptured = true;
            return;
          }
          
          // Skip cached events after initial capture
          if (eventType === 'cached' || eventType === 'initial') {
            return;
          }
          
          // Track event type for blocked GWP logic
          if (eventType === 'add' || eventType === 'cart:add') {
            self.lastEventType = 'add';
            self.blockedGwps = {};
            log('Blocked GWPs cleared (new item added)');
          } else {
            self.lastEventType = 'update';
          }
          
          // Debounce processing for cart changes
          self.debounceProcess(cart, eventType);
        });
        
        log('Subscribed to YISECartData');
      },

      captureInitialGwpState: function(cart) {
        var self = this;
        // Track any existing GWP items so we can detect when user removes them
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if (item.properties && item.properties._gwp === 'true' && item.properties._promoTitle) {
            self.previousGwpKeys[item.properties._promoTitle] = item.key;
            log('Initial GWP tracked: "' + item.properties._promoTitle + '"');
          }
        }
        log('Initial GWP state captured:', Object.keys(self.previousGwpKeys));
        // Process immediately to sync state
        self.evaluateGwps(cart, 'initial');
      },

      parseUrlParams: function() {
        var self = this;
        var params = new URLSearchParams(window.location.search);
        params.forEach(function(value, key) {
          var paramKey = key + '=' + value;
          self.urlParams[paramKey] = true;
          self.setCookie('gwp_param_' + self.hashString(paramKey), '1', 1);
          log('URL param cookie set for:', paramKey);
        });
        log('URL params captured:', this.urlParams);
      },

      hashString: function(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
          var char = str.charCodeAt(i);
          hash = ((hash << 5) - hash) + char;
          hash = hash & hash;
        }
        return Math.abs(hash).toString(36);
      },

      setCookie: function(name, value, days) {
        var expires = '';
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/; SameSite=Lax';
      },

      getCookie: function(name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) === ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
      },

      hasUrlParamCookie: function(paramKey) {
        var cookieName = 'gwp_param_' + this.hashString(paramKey);
        return this.getCookie(cookieName) === '1';
      },

      isCartMutationPaused: function() {
        try {
          var pausedUntil = parseInt(window.sessionStorage.getItem(this.cartMutationPauseKey), 10) || 0;
          if (pausedUntil > Date.now()) return true;
          window.sessionStorage.removeItem(this.cartMutationPauseKey);
        } catch (error) {
          return false;
        }
        return false;
      },

      pauseCartMutations: function() {
        try {
          window.sessionStorage.setItem(
            this.cartMutationPauseKey,
            String(Date.now() + this.cartMutationPauseMs)
          );
        } catch (error) {}
      },

      clearCartMutationPause: function() {
        try {
          window.sessionStorage.removeItem(this.cartMutationPauseKey);
        } catch (error) {}
      },

      bindCartMutationRecovery: function() {
        if (window.__yiseGwpCartMutationRecoveryBound) return;

        document.addEventListener('cart:add', function(event) {
          var source = event.detail && event.detail.source;
          if (source === 'gwp-manager' || source === 'free-samples-manager') return;
          if (window.GWPManager) {
            window.GWPManager.clearCartMutationPause();
            // A gift the customer removed stays blocked only until they add
            // something else. YISECartData never emits an 'add' event type, so
            // this DOM event is the only real signal that it happened.
            window.GWPManager.blockedGwps = {};
          }
        });
        window.__yiseGwpCartMutationRecoveryBound = true;
      },

      parseCartResponse: function(response, operation) {
        var contentType = response.headers.get('content-type') || '';
        var isJsonResponse = contentType.indexOf('application/json') !== -1 ||
                             contentType.indexOf('text/javascript') !== -1;

        if (!isJsonResponse) {
          return response.text().then(function() {
            var error = new Error(
              '[GWP] Shopify cart ' + operation + ' returned an unexpected ' +
              (contentType || 'unknown') + ' response (' + response.status + ').'
            );
            error.pauseGwpCartMutations = true;
            throw error;
          });
        }

        return response.json().then(function(data) {
          if (!response.ok) {
            var message = data && (data.description || data.message);
            var error = new Error(
              message || '[GWP] Shopify cart ' + operation + ' failed (' + response.status + ').'
            );
            // Shopify answers an overlapping cart mutation with 409; it is transient,
            // unlike the 429/430 throttle that has to back off.
            error.retryGwpCartMutation = response.status === 409;
            error.pauseGwpCartMutations = response.status === 429 || response.status === 430;
            throw error;
          }
          return data;
        });
      },

      getGwpOfferKey: function(block) {
        if (!block) return '';
        if (block.gwpOfferKey) return String(block.gwpOfferKey);
        return String(block.blockId || block.promoTitle || 'gwp') + ':' + String(block.gwpVariantId || '');
      },

      getCurrencyCode: function(cart) {
        if (cart && cart.currency) {
          if (typeof cart.currency === 'string') return cart.currency;
          return cart.currency.iso_code || cart.currency.isoCode || cart.currency.active || 'USD';
        }
        return 'USD';
      },

      getRegularItemCount: function(cart) {
        var count = 0;
        if (!cart || !cart.items) return count;

        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          var props = item.properties || {};
          var isGiftLine = props._gwp === 'true' ||
                           props['_gwp'] === 'true' ||
                           props['_first-time-gift'] ||
                           props['_byo-gift'] ||
                           props['_gift-check-box-trigger'] === 'true';
          if (!isGiftLine) {
            count += item.quantity || 0;
          }
        }

        return count;
      },

      hasSubscriptionInCart: function(cart) {
        if (!cart || !cart.items) return false;

        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].selling_plan_allocation) {
            return true;
          }
        }

        return false;
      },

      hasGiftCardInCart: function(cart) {
        if (!cart || !cart.items) return false;

        for (var i = 0; i < cart.items.length; i++) {
          if (this.isGiftCardItem(cart.items[i])) {
            return true;
          }
        }

        return false;
      },

      getGwpThresholdGapBand: function(gapCents, qualified, block) {
        if (!block || block.blockType !== 'spend') return 'not_applicable';
        if (qualified || gapCents <= 0) return 'qualified';

        var dollars = gapCents / 100;
        if (dollars < 10) return '0_9';
        if (dollars < 25) return '10_24';
        if (dollars < 50) return '25_49';
        if (dollars < 100) return '50_99';
        return '100_plus';
      },

      getGwpQuantity: function(existing) {
        if (!existing || !existing.item) return 0;
        return existing.item.quantity || 0;
      },

      getBlockForCartItem: function(item) {
        if (!item || !item.properties || !this.gwpData || !this.gwpData.blocks) {
          return null;
        }

        var promoTitle = item.properties._promoTitle || item.properties['_promoTitle'];
        var variantId = item.variant_id || item.id;

        for (var i = 0; i < this.gwpData.blocks.length; i++) {
          var block = this.gwpData.blocks[i];
          if (block.promoTitle === promoTitle && block.gwpVariantId === variantId) {
            return block;
          }
        }

        for (var j = 0; j < this.gwpData.blocks.length; j++) {
          if (this.gwpData.blocks[j].promoTitle === promoTitle) {
            return this.gwpData.blocks[j];
          }
        }

        return null;
      },

      announceGwpStatus: function(message) {
        var status = document.querySelector('[data-gwp-status]');
        if (!status || !message) return;

        status.textContent = '';
        window.setTimeout(function() {
          status.textContent = message;
        }, 0);
      },

      announceGwpError: function(message) {
        var alert = document.querySelector('[data-gwp-alert]');
        if (!alert || !message) return;

        alert.textContent = '';
        window.setTimeout(function() {
          alert.textContent = message;
        }, 0);
      },

      buildGwpAnalyticsPayload: function(block, cart, extra) {
        extra = extra || {};

        var existing = extra.existing || this.findGwpLineItem(cart, block.gwpVariantId, block.promoTitle);
        if (!existing && extra.item) {
          existing = { item: extra.item, line: null, key: extra.item.key || null };
        }
        var excludeGiftCards = block.excludeGiftCards === true;
        var eligibleValueCents = Math.round(this.calculateEligibleSubtotal(cart, excludeGiftCards) * 100);
        var thresholdCents = block.promotionAmountCents != null
          ? parseInt(block.promotionAmountCents, 10)
          : (block.promotionAmountUSD ? Math.round(parseFloat(block.promotionAmountUSD) * 100) : 0);
        var qualified = extra.qualified === true;
        var gapCents = block.blockType === 'spend' ? Math.max(0, thresholdCents - eligibleValueCents) : 0;
        var offerKey = this.getGwpOfferKey(block);
        var eventType = extra.eventType || this.lastEventType || 'unknown';
        var item = extra.item || (existing && existing.item) || null;

        var payload = {
          custom_gwp_offer_key: offerKey,
          custom_gwp_block_id: block.blockId || '',
          custom_gwp_promo_title: block.promoTitle || '',
          custom_gwp_offer_type: block.blockType || '',
          custom_gwp_program: block.gwpProgram || 'gift_with_purchase',
          custom_gwp_variant_id: block.gwpVariantId || (item && (item.variant_id || item.id)) || '',
          custom_gwp_product_id: block.gwpProductId || (item && item.product_id) || '',
          custom_gwp_sku: block.gwpSku || (item && item.sku) || '',
          custom_gwp_product_title: block.gwpProductTitle || (item && (item.product_title || item.title)) || '',
          custom_gwp_threshold_cents: thresholdCents || 0,
          custom_gwp_threshold_gap_cents: gapCents,
          custom_gwp_threshold_gap_band: this.getGwpThresholdGapBand(gapCents, qualified, block),
          custom_gwp_qualified: qualified ? 'true' : 'false',
          custom_gwp_present: existing ? 'true' : 'false',
          custom_gwp_quantity: this.getGwpQuantity(existing),
          custom_cart_total_cents: cart && cart.total_price ? cart.total_price : 0,
          custom_cart_eligible_value_cents: eligibleValueCents,
          custom_cart_item_count: cart && cart.item_count ? cart.item_count : 0,
          custom_cart_regular_item_count: this.getRegularItemCount(cart),
          custom_has_subscription: this.hasSubscriptionInCart(cart) ? 'true' : 'false',
          custom_has_gift_card: this.hasGiftCardInCart(cart) ? 'true' : 'false',
          custom_currency: this.getCurrencyCode(cart),
          custom_surface: extra.surface || 'cart_drawer',
          custom_gwp_cart_event_type: eventType,
          page_path: window.location.pathname,
          page_title: document.title
        };

        if (cart && cart.token) {
          payload.custom_cart_token_hash = this.hashString(cart.token);
        }

        if (extra.reason) {
          payload.custom_gwp_remove_reason = extra.reason;
        }

        if (extra.preThresholdValueCents != null) {
          payload.custom_gwp_pre_threshold_value_cents = extra.preThresholdValueCents;
        }

        if (extra.incrementToUnlockCents != null) {
          payload.custom_gwp_increment_to_unlock_cents = extra.incrementToUnlockCents;
        }

        if (extra.timeToUnlockSeconds != null) {
          payload.custom_gwp_time_to_unlock_seconds = extra.timeToUnlockSeconds;
        }

        if (extra.cartMutationsToUnlock != null) {
          payload.custom_gwp_cart_mutations_to_unlock = extra.cartMutationsToUnlock;
        }

        return payload;
      },

      dispatchGwpAnalyticsEvent: function(eventName, payload) {
        document.dispatchEvent(new CustomEvent('gwp:' + eventName, {
          bubbles: true,
          detail: payload || {}
        }));
      },

      trackGwpAnalytics: function(block, cart, eventType, qualified, existing) {
        if (!block || !cart) return;

        var offerKey = this.getGwpOfferKey(block);
        var now = Date.now();
        var previous = this.analyticsState[offerKey] || null;
        var basePayload = this.buildGwpAnalyticsPayload(block, cart, {
          eventType: eventType,
          qualified: qualified,
          existing: existing
        });

        var sessionKey = 'yise_gwp_offer_available_' + this.hashString(offerKey);
        var sentAvailability = this.analyticsOfferAvailability[offerKey] === true;
        try {
          sentAvailability = sentAvailability || window.sessionStorage.getItem(sessionKey) === '1';
        } catch (e) {}

        if (!sentAvailability && this.isBlockActive(block)) {
          this.analyticsOfferAvailability[offerKey] = true;
          try {
            window.sessionStorage.setItem(sessionKey, '1');
          } catch (e) {}
          this.dispatchGwpAnalyticsEvent('offer_available', basePayload);
        }

        var isMutation = eventType &&
                         eventType !== 'initial' &&
                         eventType !== 'cached' &&
                         eventType !== 'vue-refresh';
        if (isMutation) {
          this.analyticsMutationCounts[offerKey] = (this.analyticsMutationCounts[offerKey] || 0) + 1;
        }

        var signature = [
          basePayload.custom_gwp_qualified,
          basePayload.custom_gwp_present,
          basePayload.custom_gwp_quantity,
          basePayload.custom_gwp_threshold_gap_band
        ].join('|');

        if (!previous || previous.signature !== signature) {
          this.dispatchGwpAnalyticsEvent('cart_state', basePayload);
        }

        if (previous && previous.qualified !== qualified) {
          if (qualified) {
            this.dispatchGwpAnalyticsEvent('threshold_reached', this.buildGwpAnalyticsPayload(block, cart, {
              eventType: eventType,
              qualified: qualified,
              existing: existing,
              preThresholdValueCents: previous.eligibleValueCents,
              incrementToUnlockCents: Math.max(0, basePayload.custom_cart_eligible_value_cents - previous.eligibleValueCents),
              timeToUnlockSeconds: Math.round((now - previous.firstSeenAt) / 1000),
              cartMutationsToUnlock: this.analyticsMutationCounts[offerKey] || 0
            }));
          } else {
            this.dispatchGwpAnalyticsEvent('threshold_lost', basePayload);
          }
        }

        this.analyticsState[offerKey] = {
          qualified: qualified,
          signature: signature,
          eligibleValueCents: basePayload.custom_cart_eligible_value_cents,
          firstSeenAt: previous ? previous.firstSeenAt : now
        };
      },

      hasRecordedRemoval: function(toRemove, key) {
        for (var i = 0; i < toRemove.length; i++) {
          if (toRemove[i].key === key) {
            return true;
          }
        }
        return false;
      },

      recordGwpRemoval: function(toRemove, key, block, item, reason) {
        if (!key || this.hasRecordedRemoval(toRemove, key)) {
          return;
        }

        toRemove.push({
          key: key,
          block: block || this.getBlockForCartItem(item),
          item: item || null,
          reason: reason || 'unknown'
        });
      },

      getRemovalQualifiedState: function(block, cart, reason) {
        if (!block || !cart) return false;
        if (reason === this.removalReasons.thresholdLost.reason || reason === this.removalReasons.inactiveOffer.reason) {
          return false;
        }
        if (block.blockType === 'spend') {
          return this.checkSpendQualification(block, cart);
        }
        if (block.blockType === 'bogo') {
          return this.checkBogoQualification(block, cart);
        }
        return false;
      },

      flushGwpRemovals: function(removals, sourceCart) {
        if (!removals || removals.length === 0) {
          return;
        }

        var cart = sourceCart || (window.YISECartData && window.YISECartData.cart);
        if (!cart) return;

        var removedGiftTitles = [];
        var removalReasons = {};
        for (var i = 0; i < removals.length; i++) {
          var removal = removals[i];
          if (!removal.block) continue;
          var qualified = this.getRemovalQualifiedState(removal.block, cart, removal.reason);

          removedGiftTitles.push(
            (removal.item && (removal.item.product_title || removal.item.title)) ||
            removal.block.gwpProductTitle ||
            'free gift'
          );
          removalReasons[removal.reason] = true;

          this.dispatchGwpAnalyticsEvent('gift_removed', this.buildGwpAnalyticsPayload(removal.block, cart, {
            eventType: this.lastEventType || 'gwp_removal',
            qualified: qualified,
            item: removal.item,
            reason: removal.reason
          }));

          var giftTitle = removal.item && (removal.item.product_title || removal.item.title);
          if (!giftTitle && removal.block) giftTitle = removal.block.gwpProductTitle;
          if (removal.reason === this.removalReasons.thresholdLost.reason) {
            this.announceGwpStatus(
              giftTitle
                ? 'Free gift ' + giftTitle + ' was removed because your cart no longer qualifies.'
                : 'Your free gift was removed because your cart no longer qualifies.'
            );
          } else {
            this.announceGwpStatus(
              giftTitle ? 'Free gift ' + giftTitle + ' was removed from your cart.' : 'Your free gift was removed from your cart.'
            );
          }
        }

      },

      debounceProcess: function(cart, eventType) {
        var self = this;
        if (this.processQueue) {
          clearTimeout(this.processQueue);
        }
        this.processQueue = setTimeout(function() {
          if (cart) {
            self.processCartData(cart, eventType);
          } else {
            self.processCart();
          }
        }, 200);
      },

      isBlockActive: function(block) {
        // Time-based filtering is handled server-side in Liquid
        // Only URL param check is needed client-side (for cookie persistence)
        if (block.urlParam) {
          var hasCurrentParam = this.urlParams[block.urlParam];
          var hasCookie = this.hasUrlParamCookie(block.urlParam);
          
          if (!hasCurrentParam && !hasCookie) {
            log('Block "' + block.promoTitle + '" URL param not matched (no cookie or current param)');
            return false;
          }
          
          log('Block "' + block.promoTitle + '" URL param matched via ' + (hasCurrentParam ? 'current URL' : '24h cookie'));
        }

        return true;
      },

      /**
       * Check if a cart item is a gift card product
       * Checks: gift_card boolean, product_type, title, and tags
       * @param {Object} item - The cart line item
       * @returns {boolean} - True if item is a gift card
       */
      isGiftCardItem: function(item) {
        // Check Shopify's built-in gift_card boolean
        if (item.gift_card) {
          return true;
        }
        
        // Check product type contains "gift card" (case-insensitive)
        if (item.product_type) {
          var productType = item.product_type.toLowerCase();
          if (productType === 'gift card' || productType === 'gift cards' || productType.indexOf('gift card') !== -1) {
            return true;
          }
        }
        
        // Check product title contains "Gift Card" (case-insensitive)
        if (item.product_title) {
          var productTitle = item.product_title.toLowerCase();
          if (productTitle.indexOf('gift card') !== -1) {
            return true;
          }
        }
        
        // Check line item title contains "Gift Card" (case-insensitive)
        if (item.title) {
          var lineTitle = item.title.toLowerCase();
          if (lineTitle.indexOf('gift card') !== -1) {
            return true;
          }
        }
        
        // Check product tags for "gift card" (case-insensitive)
        if (item.tags && Array.isArray(item.tags)) {
          for (var j = 0; j < item.tags.length; j++) {
            var tag = item.tags[j].toLowerCase();
            if (tag === 'gift card' || tag === 'gift-card' || tag === 'giftcard') {
              return true;
            }
          }
        }
        
        return false;
      },

      calculateEligibleSubtotal: function(cart, excludeGiftCards) {
        var self = this;
        var subtotal = 0;
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];

          if (item.properties && item.properties._gwp) {
            continue;
          }

          if (excludeGiftCards && self.isGiftCardItem(item)) {
            log('Excluding gift card from GWP subtotal:', item.title);
            continue;
          }

          subtotal += item.original_price * item.quantity;
        }
        return subtotal / 100;
      },

      checkSpendQualification: function(block, cart) {
        var threshold = parseFloat(block.promotionAmountUSD) || 0;
        var excludeGiftCards = block.excludeGiftCards === true;
        var subtotal = this.calculateEligibleSubtotal(cart, excludeGiftCards);
        log('Spend check for "' + block.promoTitle + '": subtotal=' + subtotal + ', threshold=' + threshold);
        return subtotal >= threshold;
      },

      checkBogoQualification: function(block, cart) {
        var triggerVariants = block.triggerVariants || [];
        var sellingPlanFilter = block.sellingPlan || 'all';

        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];

          if (item.properties && item.properties._gwp) {
            continue;
          }

          if (sellingPlanFilter === 'onetime') {
            if (item.selling_plan_allocation) {
              continue;
            }
          } else if (sellingPlanFilter === 'subscription') {
            if (!item.selling_plan_allocation) {
              continue;
            }
          }

          var variantId = item.variant_id || item.id;
          if (triggerVariants.indexOf(variantId) !== -1) {
            log('BOGO trigger found for "' + block.promoTitle + '": variant ' + variantId);
            return true;
          }

          var itemComponents = Array.isArray(item.item_components) ? item.item_components : [];
          for (var c = 0; c < itemComponents.length; c++) {
            var componentVariantId = itemComponents[c].variant_id || itemComponents[c].id;
            if (triggerVariants.indexOf(componentVariantId) !== -1) {
              log('BOGO trigger found for "' + block.promoTitle + '": component variant ' + componentVariantId);
              return true;
            }
          }

          var bundleProducts = itemComponents.length === 0 && Array.isArray(item.bundle_products) ? item.bundle_products : [];
          for (var bp = 0; bp < bundleProducts.length; bp++) {
            var bundleVariantId = bundleProducts[bp].variant_id || bundleProducts[bp].id;
            if (triggerVariants.indexOf(bundleVariantId) !== -1) {
              log('BOGO trigger found for "' + block.promoTitle + '": bundle product variant ' + bundleVariantId);
              return true;
            }
          }
        }

        return false;
      },

      findGwpLineItem: function(cart, variantId, promoTitle) {
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if ((item.variant_id === variantId || item.id === variantId) && 
              item.properties && 
              item.properties._gwp === 'true' &&
              item.properties._promoTitle === promoTitle) {
            return { item: item, line: i + 1, key: item.key };
          }
        }
        return null;
      },

      /**
       * Variant ids of a line item's bundle components that cost the customer nothing.
       * A cart transform merges a Build Your Own Set into one parent line whose
       * item_components list the products the customer paid for alongside the set's
       * own free gift, and components carry no properties, so price is the only
       * signal that separates the two.
       */
      getFreeBundleComponentVariants: function(item) {
        var components = (item && item.item_components) || [];
        var freeVariants = [];

        for (var i = 0; i < components.length; i++) {
          var component = components[i];
          var variantId = component.variant_id || component.id;
          if (variantId && (component.price || 0) === 0) {
            freeVariants.push(variantId);
          }
        }

        return freeVariants;
      },

      isVariantAlreadyGwp: function(cart, variantId) {
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];

          // Match top-level GWP items (excluding free samples) and standalone BYO gifts
          if ((item.variant_id === variantId || item.id === variantId) &&
              item.properties) {
            var isGwp = item.properties._gwp === 'true' &&
                        item.properties['_gwp-free-sample'] !== 'true';
            var isByoGift = !!item.properties['_byo-gift'];
            if (isGwp || isByoGift) {
              return true;
            }
          }

          // Match free bundle components (e.g. BYO bundle gift nested under the parent).
          // A paid component is a product the customer bought inside their set and
          // must not cancel the gift offer for that same variant.
          if (this.getFreeBundleComponentVariants(item).indexOf(variantId) !== -1) {
            return true;
          }
        }
        return false;
      },

      /**
       * Process cart - fetches cart if not provided
       */
      processCart: function() {
        var self = this;
        
        if (this.isProcessing) {
          log('Already processing, queuing...');
          this.debounceProcess();
          return;
        }

        // Use YISECartData to get cart
        if (window.YISECartData) {
          window.YISECartData.get().then(function(cart) {
            self.processCartData(cart, 'fetch');
          }).catch(function(error) {
            console.error('[GWP] Error getting cart:', error);
          });
        }
      },
      
      /**
       * Process cart data directly (when already have cart data from subscriber)
       */
      processCartData: function(cart, eventType) {
        if (this.isProcessing) {
          log('Already processing, queuing...');
          this.debounceProcess(cart, eventType);
          return;
        }

        var self = this;
        this.isProcessing = true;

        try {
          log('Processing cart data');
          this.evaluateGwps(cart, eventType || 'cart_update');
        } catch (error) {
          console.error('[GWP] Error processing cart:', error);
        } finally {
          this.isProcessing = false;
        }
      },

      evaluateGwps: function(cart, eventType) {
        var self = this;
        var toAdd = [];
        var toRemove = [];
        var currentGwpKeys = {};

        for (var i = 0; i < this.gwpData.blocks.length; i++) {
          var block = this.gwpData.blocks[i];

          if (!this.isBlockActive(block)) {
            var existingInactive = this.findGwpLineItem(cart, block.gwpVariantId, block.promoTitle);
            if (existingInactive) {
              this.recordGwpRemoval(toRemove, existingInactive.key, block, existingInactive.item, this.removalReasons.inactiveOffer.reason);
              log('Removing inactive GWP "' + block.promoTitle + '"');
            }
            continue;
          }

          var qualifies = false;
          if (block.blockType === 'spend') {
            qualifies = this.checkSpendQualification(block, cart);
          } else if (block.blockType === 'bogo') {
            qualifies = this.checkBogoQualification(block, cart);
          }

          var existing = this.findGwpLineItem(cart, block.gwpVariantId, block.promoTitle);

          this.trackGwpAnalytics(block, cart, eventType || 'cart_update', qualifies, existing);
          
          if (existing) {
            currentGwpKeys[block.promoTitle] = existing.key;
          }

          var wasPreviouslyInCart = this.previousGwpKeys[block.promoTitle];
          var wasUserRemoved = wasPreviouslyInCart && !existing && qualifies;
          
          if (wasUserRemoved) {
            this.blockedGwps[block.promoTitle] = true;
            this.dispatchGwpAnalyticsEvent('gift_removed', this.buildGwpAnalyticsPayload(block, cart, {
              eventType: eventType || 'cart_update',
              qualified: qualifies,
              reason: this.removalReasons.userRemoved.reason
            }));
            log('User removed GWP "' + block.promoTitle + '" - blocking re-add until next cart add');
          }

          if (qualifies && !existing) {
            if (this.blockedGwps[block.promoTitle]) {
              log('GWP "' + block.promoTitle + '" is blocked (user removed) - skipping');
            } else if (this.isVariantAlreadyGwp(cart, block.gwpVariantId)) {
              log('GWP variant ' + block.gwpVariantId + ' already in cart as another GWP - skipping "' + block.promoTitle + '"');
            } else {
              toAdd.push(block);
              log('Should add GWP "' + block.promoTitle + '"');
            }
          } else if (!qualifies && existing) {
            this.recordGwpRemoval(toRemove, existing.key, block, existing.item, this.removalReasons.thresholdLost.reason);
            log('Should remove GWP "' + block.promoTitle + '" (no longer qualifies)');
            delete this.blockedGwps[block.promoTitle];
            delete currentGwpKeys[block.promoTitle];
          } else if (existing && existing.item.quantity > 1) {
            log('GWP "' + block.promoTitle + '" has qty > 1, will fix');
            this.recordGwpRemoval(toRemove, existing.key, block, existing.item, this.removalReasons.quantityCorrection.reason);
            if (qualifies) {
              toAdd.push(block);
            }
          }
          
          if (!qualifies) {
            delete this.blockedGwps[block.promoTitle];
          }
        }

        this.previousGwpKeys = currentGwpKeys;
        this.cleanupDuplicateGwps(cart, toRemove);

        if (toRemove.length === 0 && toAdd.length === 0) {
          log('No GWP changes needed');
          return Promise.resolve();
        }

        return this.executeChanges(toRemove, toAdd, cart);
      },

      cleanupDuplicateGwps: function(cart, toRemove) {
        var gwpByPromo = {};
        var gwpByVariant = {};
        var byoGiftVariants = {};
        var bundleComponentVariants = {};

        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];

          // Track variants the customer already receives free as a bundle component
          // (e.g. BYO bundle gift nested under the parent line item). Paid components
          // are purchases, not gifts, so they never deduplicate an offer.
          var freeComponentVariants = this.getFreeBundleComponentVariants(item);
          for (var c = 0; c < freeComponentVariants.length; c++) {
            bundleComponentVariants[freeComponentVariants[c]] = true;
          }

          if (!item.properties) {
            continue;
          }

          var variantId = item.variant_id || item.id;

          // Standalone BYO gift line items
          if (item.properties['_byo-gift']) {
            byoGiftVariants[variantId] = true;
          }

          // GWP items (excluding free samples, managed separately)
          var isGwp = item.properties._gwp === 'true' &&
                      item.properties['_gwp-free-sample'] !== 'true';
          if (!isGwp) {
            continue;
          }

          if (item.properties._promoTitle) {
            var promoKey = item.properties._promoTitle;
            if (!gwpByPromo[promoKey]) {
              gwpByPromo[promoKey] = [];
            }
            gwpByPromo[promoKey].push({
              key: item.key,
              item: item,
              block: this.getBlockForCartItem(item)
            });
          }

          if (!gwpByVariant[variantId]) {
            gwpByVariant[variantId] = [];
          }
          gwpByVariant[variantId].push({
            key: item.key,
            item: item,
            block: this.getBlockForCartItem(item)
          });
        }

        // Remove duplicates by promo title (same promo added multiple times)
        for (var promoTitle in gwpByPromo) {
          if (gwpByPromo[promoTitle].length > 1) {
            for (var j = 1; j < gwpByPromo[promoTitle].length; j++) {
              this.recordGwpRemoval(toRemove, gwpByPromo[promoTitle][j].key, gwpByPromo[promoTitle][j].block, gwpByPromo[promoTitle][j].item, this.removalReasons.duplicatePromo.reason);
              log('Removing duplicate GWP for promo ' + promoTitle);
            }
          }
        }

        // Remove GWP entries that duplicate a variant already provided
        // as a BYO gift line item or as a bundle component. Bundle items
        // are never removed — they belong to the parent bundle.
        for (var variantId in gwpByVariant) {
          var keys = gwpByVariant[variantId];
          var coveredByBundle = byoGiftVariants[variantId] || bundleComponentVariants[variantId];

          if (coveredByBundle) {
            for (var k = 0; k < keys.length; k++) {
              this.recordGwpRemoval(toRemove, keys[k].key, keys[k].block, keys[k].item, this.removalReasons.duplicateVariant.reason);
              log('Removing GWP variant ' + variantId + ' (already in cart as bundle gift/component)');
            }
          } else if (keys.length > 1) {
            for (var m = 1; m < keys.length; m++) {
              this.recordGwpRemoval(toRemove, keys[m].key, keys[m].block, keys[m].item, this.removalReasons.duplicateVariant.reason);
              log('Removing duplicate GWP variant ' + variantId + ' (different promo)');
            }
          }
        }
      },

      executeChanges: function(toRemove, toAdd, cart) {
        var self = this;

        if (this.isCartMutationPaused()) {
          log('Cart mutations temporarily paused after an unexpected Shopify response');
          return Promise.resolve();
        }

        var removePromise = Promise.resolve();
        if (toRemove.length > 0) {
          var updates = {};
          for (var i = 0; i < toRemove.length; i++) {
            updates[toRemove[i].key] = 0;
          }
          removePromise = fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'X-GWP-Request': 'true'
            },
            body: JSON.stringify({ updates: updates })
          }).then(function(res) { return self.parseCartResponse(res, 'update'); })
            .then(function(data) {
              self.flushGwpRemovals(toRemove, cart);
              return data;
            });
        }

        return removePromise.then(function() {
          if (toAdd.length === 0) {
            self.refreshCartUI();
            return;
          }

          return self.addGwpItems(toAdd).then(function(added) {
            if (added.length > 0) {
              self.refreshCartUI();
            }
          });
        }).catch(function(error) {
          if (error && error.pauseGwpCartMutations) {
            self.pauseCartMutations();
          }
          console.error('[GWP] Error updating free gift:', error);
          self.announceGwpError('We could not update your free gift. Please try again after updating your cart.');
        });
      },

      buildGwpLineItem: function(block) {
        var properties = {
          '_gwp': 'true',
          '_promoTitle': block.promoTitle,
          '_gwp_pricing_mode': block.pricingMode || 'discount'
        };

        if ((block.pricingMode || 'discount') === 'discount') {
          properties['_freeGiftDiscount'] = 'true';
        }

        if (block.blockType === 'spend' && block.promotionAmountUSD) {
          properties['_gwp_threshold'] = block.promotionAmountUSD;
          properties['_gwp_exclude_gift_cards'] = block.excludeGiftCards === true ? 'true' : 'false';
        }

        if (block.gwpBlockDiscountCodes === true) {
          properties['_gwpPreventDiscountCodes'] = 'true';
        }

        return {
          id: block.gwpVariantId,
          quantity: 1,
          properties: properties
        };
      },

      getGiftTitle: function(block, item) {
        return (item && (item.product_title || item.title)) || (block && block.gwpProductTitle) || '';
      },

      announceGwpAdditions: function(titles) {
        var named = titles.filter(function(title) { return !!title; });

        if (named.length === 0) {
          this.announceGwpStatus('A free gift was added to your cart.');
        } else if (named.length === 1) {
          this.announceGwpStatus('Free gift ' + named[0] + ' was added to your cart.');
        } else {
          var list = named.slice(0, -1).join(', ') + ' and ' + named[named.length - 1];
          this.announceGwpStatus('Free gifts ' + list + ' were added to your cart.');
        }
      },

      matchAddedGwpItems: function(blocks, addedItems) {
        var claimed = {};

        return blocks.map(function(block, index) {
          for (var i = 0; i < addedItems.length; i++) {
            var item = addedItems[i];
            if (claimed[i]) continue;
            if (item && (item.variant_id === block.gwpVariantId || item.id === block.gwpVariantId)) {
              claimed[i] = true;
              return item;
            }
          }
          if (!claimed[index] && addedItems[index]) {
            claimed[index] = true;
            return addedItems[index];
          }
          return null;
        });
      },

      handleGwpAdditions: function(blocks, addedItems) {
        var self = this;
        var cart = window.YISECartData && window.YISECartData.cart
          ? window.YISECartData.cart
          : { items: [], total_price: 0, item_count: 0 };
        var matchedItems = this.matchAddedGwpItems(blocks, addedItems);
        var titles = [];

        blocks.forEach(function(block, index) {
          var item = matchedItems[index];
          self.previousGwpKeys[block.promoTitle] = (item && item.key) || true;
          self.dispatchGwpAnalyticsEvent('gift_added', self.buildGwpAnalyticsPayload(block, cart, {
            eventType: 'gwp_add',
            qualified: true,
            item: item
          }));
          titles.push(self.getGiftTitle(block, item));
          log('Tracking GWP "' + block.promoTitle + '" as previously in cart');
        });

        self.announceGwpAdditions(titles);

        document.dispatchEvent(new CustomEvent('cart:add', {
          bubbles: true,
          detail: {
            items: matchedItems.map(function(item, index) {
              var title = self.getGiftTitle(blocks[index], item) || 'item';
              return Object.assign({}, item || {}, {
                product_title: 'Free gift: ' + title + ' for your qualifying purchase'
              });
            }),
            source: 'gwp-manager'
          }
        }));
      },

      /**
       * Adds every qualifying gift in one cart/add.js call. Shopify's Cart AJAX API
       * rejects overlapping mutations with a 409 rather than queueing them, so parallel
       * adds drop all but the first; one batched request is also a single round trip
       * instead of one per gift.
       */
      addGwpItems: function(blocks, isRetry) {
        var self = this;

        if (!blocks || blocks.length === 0) {
          return Promise.resolve([]);
        }

        var formData = {
          items: blocks.map(function(block) {
            return self.buildGwpLineItem(block);
          })
        };

        log('Adding GWP items:', formData);

        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-GWP-Request': 'true'
          },
          body: JSON.stringify(formData)
        })
        .then(function(response) {
          return self.parseCartResponse(response, 'add');
        })
        .then(function(data) {
          log('GWP added successfully:', data);
          var addedItems = (data && data.items) || [];
          if (addedItems.length > 0) {
            self.handleGwpAdditions(blocks, addedItems);
          }
          return addedItems;
        })
        .catch(function(error) {
          if (error && error.retryGwpCartMutation && !isRetry) {
            log('Cart conflicted while adding gifts - retrying once');
            return new Promise(function(resolve) {
              setTimeout(resolve, 250);
            }).then(function() {
              return self.addGwpItems(blocks, true);
            });
          }

          // cart/add.js is atomic, so one unavailable gift rejects the whole batch.
          // Retry the rest one at a time so a single bad variant cannot block them.
          if (blocks.length > 1) {
            log('Batched GWP add failed - falling back to one request per gift');
            return self.addGwpItemsSequentially(blocks);
          }

          if (error && error.pauseGwpCartMutations) {
            self.pauseCartMutations();
          }
          console.error('[GWP] Error adding GWP:', error);
          self.announceGwpError('We could not add your free gift. Please try again after updating your cart.');
          return [];
        });
      },

      addGwpItemsSequentially: function(blocks) {
        var self = this;
        var addedItems = [];

        return blocks.reduce(function(chain, block) {
          return chain.then(function() {
            return self.addGwpItems([block]).then(function(added) {
              addedItems = addedItems.concat(added);
            });
          });
        }, Promise.resolve()).then(function() {
          return addedItems;
        });
      },

      refreshCartUI: function() {
        this.skipNextProcess = true;
        // Use YISECartData to refresh - this will notify all subscribers including miniCart
        if (window.YISECartData) {
          window.YISECartData.refresh('gwp-update');
        }
      }
    };

    function scheduleGwpInit() {
      var init = function() {
        GWPManager.init();
      };

      var deferInit = function() {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(init, { timeout: 2500 });
        } else {
          setTimeout(init, 1200);
        }
      };

      if (document.readyState === 'complete') {
        deferInit();
      } else {
        window.addEventListener('load', deferInit, { once: true });
      }
    }

    window.GWPManager = GWPManager;
    GWPManager.bindCartMutationRecovery();
    scheduleGwpInit();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-new"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

    /* ========================================
       DYNAMIC NAV BREAKPOINT - read from <header data-nav-breakpoint>
       Calculated server-side in header-new.liquid based on link text width.
       ======================================== */
    function getNavBreakpoint() {
      var h = document.querySelector('#js-header');
      var v = h && h.dataset ? parseInt(h.dataset.navBreakpoint, 10) : NaN;
      return isNaN(v) ? 1024 : v;
    }
    function isMobileNav() {
      return window.innerWidth < getNavBreakpoint();
    }

    function whenSwiperReady(callback) {
      if (typeof window.Swiper === 'function') {
        callback();
        return;
      }

      window.addEventListener('yise:swiper-ready', callback, { once: true });
    }

    /* ========================================
       SCROLL HANDLER - scrolled class on body
       ======================================== */
    var lastScrolledState = null;
    function handleScroll() {
      var nextScrolledState = window.scrollY >= 40;
      if (nextScrolledState === lastScrolledState) return;

      lastScrolledState = nextScrolledState;
      if (nextScrolledState) {
        document.body.classList.add('scrolled');
      } else {
        document.body.classList.remove('scrolled');
      }
    }

    var scrollUpdatePending = false;
    function requestScrollUpdate() {
      if (scrollUpdatePending) return;

      scrollUpdatePending = true;
      window.requestAnimationFrame(function () {
        handleScroll();
        scrollUpdatePending = false;
      });
    }

    window.addEventListener('scroll', requestScrollUpdate, { passive: true });
    handleScroll(); /* Run on load to set initial state */
    
    /* ========================================
       SEARCH TOGGLE - js-toggle-search
       ======================================== */
    var searchToggles = document.getElementsByClassName('js-toggle-search');
    var searchOverlay = document.querySelector('[data-search-panel]');
    
    function handleSearchToggle(e) {
      e.preventDefault();
      /* Immediately close mega menu (cancel any pending timeout) */
      if (typeof immediateCloseMegaMenu === 'function') {
        immediateCloseMegaMenu();
      } else {
        document.body.classList.remove('mega-menu-open');
      }
      var isOpen = document.body.classList.contains('search-open');

      if (isOpen) {
        document.dispatchEvent(new CustomEvent('search:close'));
        document.body.classList.remove('no-scroll', 'search-open');
        e.currentTarget.focus();
      } else {
        document.body.dataset.searchTrigger = e.currentTarget.id;
        document.body.classList.add('no-scroll', 'search-open');
        document.dispatchEvent(new CustomEvent('search:open', {
          detail: { trigger: e.currentTarget.id }
        }));
        window.requestAnimationFrame(function () {
          var searchInput = document.querySelector('[data-search-input]');
          if (searchInput) {
            searchInput.focus();
          }
        });
      }

      syncSearchToggleState();
    }
    
    for (var i = 0; i < searchToggles.length; i++) {
      searchToggles[i].addEventListener('click', handleSearchToggle, false);
    }

    function syncSearchToggleState() {
      var isOpen = document.body.classList.contains('search-open');
      if (!searchOverlay) {
        searchOverlay = document.querySelector('[data-search-panel]');
      }
      for (var searchIndex = 0; searchIndex < searchToggles.length; searchIndex++) {
        searchToggles[searchIndex].setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (searchOverlay && searchOverlay.id) {
          searchToggles[searchIndex].setAttribute('aria-controls', searchOverlay.id);
        }
      }
    }

    syncSearchToggleState();
    document.addEventListener('DOMContentLoaded', syncSearchToggleState);
    new MutationObserver(syncSearchToggleState).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    /* ========================================
       CART TOGGLE - js-toggle-cart (close mega menu)
       ======================================== */
    var cartToggles = document.getElementsByClassName('js-toggle-cart');
    
    function handleCartToggleForMegaMenu() {
      /* Immediately close mega menu when cart is clicked (cancel any pending timeout) */
      if (typeof immediateCloseMegaMenu === 'function') {
        immediateCloseMegaMenu();
      }
    }
    
    for (var c = 0; c < cartToggles.length; c++) {
      cartToggles[c].addEventListener('click', handleCartToggleForMegaMenu, false);
    }
    
    /* ========================================
       NAV TOGGLE - js-toggle-nav (hamburger)
       ======================================== */
    var navToggles = document.querySelectorAll('.hamburger.js-toggle-nav[aria-controls]');
    var mobileMenuPanel = document.getElementById('main-menu-mobile-panel');
    var mobileMenuClose = mobileMenuPanel ? mobileMenuPanel.querySelector('[data-mobile-menu-close]') : null;

    function getMobileMenuFocusableElements() {
      if (!mobileMenuPanel) return [];

      return Array.prototype.slice.call(mobileMenuPanel.querySelectorAll('a[href], button:not([disabled]), summary, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function(element) {
        return element.getClientRects().length > 0;
      });
    }

    var mobileMenuBackgroundState = [];

    function setMobileMenuBackgroundInert(isOpen) {
      if (!mobileMenuPanel) return;

      if (isOpen) {
        /* The hamburger renders as the drawer's X and must stay clickable, so it
           and the panel are kept live while everything around them goes inert. */
        var liveElements = [mobileMenuPanel];
        for (var toggleIndex = 0; toggleIndex < navToggles.length; toggleIndex++) {
          liveElements.push(navToggles[toggleIndex]);
        }

        var isLive = function(element) {
          return liveElements.indexOf(element) !== -1;
        };

        var wrapsLive = function(element) {
          for (var liveIndex = 0; liveIndex < liveElements.length; liveIndex++) {
            if (element.contains(liveElements[liveIndex])) return true;
          }
          return false;
        };

        var makeInert = function(element) {
          var isTracked = false;
          for (var recordIndex = 0; recordIndex < mobileMenuBackgroundState.length; recordIndex++) {
            if (mobileMenuBackgroundState[recordIndex].element === element) {
              isTracked = true;
              break;
            }
          }
          if (!isTracked) {
            mobileMenuBackgroundState.push({
              element: element,
              inert: element.inert,
              inertAttribute: element.getAttribute('inert'),
              ariaHidden: element.getAttribute('aria-hidden')
            });
          }
          element.setAttribute('inert', '');
          element.inert = true;
          element.setAttribute('aria-hidden', 'true');
        };

        var inertAround = function(parent) {
          var children = parent.children;
          for (var childIndex = 0; childIndex < children.length; childIndex++) {
            var child = children[childIndex];
            if (isLive(child)) continue;
            if (wrapsLive(child)) {
              inertAround(child);
              continue;
            }
            makeInert(child);
          }
        };

        inertAround(document.body);
        return;
      }

      mobileMenuBackgroundState.forEach(function(record) {
        record.element.inert = record.inert;
        if (record.inertAttribute == null) {
          record.element.removeAttribute('inert');
        } else {
          record.element.setAttribute('inert', record.inertAttribute);
        }
        if (record.ariaHidden == null) {
          record.element.removeAttribute('aria-hidden');
        } else {
          record.element.setAttribute('aria-hidden', record.ariaHidden);
        }
      });
      mobileMenuBackgroundState = [];
    }

    function syncMobileMenuModalState(isOpen) {
      var isMobileMenuOpen = isOpen && isMobileNav();
      setMobileMenuBackgroundInert(isMobileMenuOpen);
    }

    function focusMobileMenu() {
      var focusableElements = getMobileMenuFocusableElements();
      if (focusableElements.length) {
        focusableElements[0].focus();
      }
    }

    function handleNavToggle(e, action) {
      if (e) e.preventDefault();
      action = action || 'toggle';
      
      switch (action) {
        case 'close':
          document.body.classList.remove('mega-menu-open');
          break;
        case 'open':
          document.body.classList.add('mega-menu-open');
          break;
        case 'toggle':
        default:
          document.body.classList.toggle('mega-menu-open');
          break;
      }
      if (document.body.classList.contains('search-open')) {
        document.dispatchEvent(new CustomEvent('search:close'));
        document.body.classList.remove('no-scroll', 'search-open');
      }
      syncNavToggleState();

      if (document.body.classList.contains('mega-menu-open')) {
        window.requestAnimationFrame(focusMobileMenu);
      } else if (navToggles.length) {
        navToggles[0].focus();
      }
    }
    
    for (var j = 0; j < navToggles.length; j++) {
      navToggles[j].addEventListener('click', handleNavToggle, false);
    }

    if (mobileMenuClose) {
      mobileMenuClose.addEventListener('click', function(e) {
        handleNavToggle(e, 'close');
      }, false);
    }

    function syncNavToggleState() {
      var isOpen = document.body.classList.contains('mega-menu-open');
      for (var navIndex = 0; navIndex < navToggles.length; navIndex++) {
        var navToggle = navToggles[navIndex];
        navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        var navLabel = navToggle.getAttribute(isOpen ? 'data-nav-close-label' : 'data-nav-open-label');
        if (navLabel) {
          navToggle.setAttribute('aria-label', navLabel);
          var navLabelText = navToggle.querySelector('[data-nav-toggle-label]');
          if (navLabelText) navLabelText.textContent = navLabel;
        }
      }
      if (mobileMenuPanel) {
        mobileMenuPanel.hidden = !isOpen || !isMobileNav();
        if (!mobileMenuPanel.hidden) {
          mobileMenuPanel.querySelectorAll('.mobile-menu__details').forEach(function(detailsEl) {
            var toggle = detailsEl.querySelector('.mobile-menu__toggle');
            var panel = detailsEl.querySelector('.mobile-submenu');
            if (toggle && panel && toggle.getAttribute('aria-expanded') === 'true') {
              panel.hidden = false;
              panel.style.maxHeight = panel.scrollHeight + 'px';
            }
          });
        }
      }
      syncMobileMenuModalState(isOpen);
    }

    syncNavToggleState();
    new MutationObserver(syncNavToggleState).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    document.addEventListener('keydown', function(event) {
      if (!isMobileNav() || !mobileMenuPanel || mobileMenuPanel.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        document.body.classList.remove('mega-menu-open');
        syncNavToggleState();
        if (navToggles.length) {
          navToggles[0].focus();
        }
        return;
      }

      if (event.key !== 'Tab') return;

      var focusableElements = getMobileMenuFocusableElements();
      if (!focusableElements.length) {
        event.preventDefault();
        return;
      }

      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];
      var activeElement = document.activeElement;

      if (event.shiftKey && (activeElement === firstFocusable || !mobileMenuPanel.contains(activeElement))) {
        event.preventDefault();
        lastFocusable.focus();
      } else if (!event.shiftKey && (activeElement === lastFocusable || !mobileMenuPanel.contains(activeElement))) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });

    function syncCartToggleState() {
      var isOpen = document.body.classList.contains('mini-cart-open');
      for (var cartIndex = 0; cartIndex < cartToggles.length; cartIndex++) {
        cartToggles[cartIndex].setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
    }

    syncCartToggleState();
    new MutationObserver(syncCartToggleState).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    /* ========================================
       CLOSE MEGA MENU - js-close-mega
       ======================================== */
    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-mega-menu-close]')) {
        e.preventDefault();
        immediateCloseMegaMenu(true);
      }
    });
    
    /* ========================================
       MEGA MENU SWIPERS INITIALIZATION
       ======================================== */
    var megaMenuSwiperInitRequested = false;
    var megaMenuSwiperResizeBound = false;

    function syncMegaMenuSwiperAccessibility(swiper, label) {
      var bounds = swiper.el.getBoundingClientRect();
      swiper.el.setAttribute('role', 'group');
      swiper.el.setAttribute('aria-roledescription', 'carousel');
      swiper.el.setAttribute('aria-label', label);

      swiper.slides.forEach(function(slide) {
        var slideBounds = slide.getBoundingClientRect();
        var isVisible = slideBounds.left >= bounds.left - 1 && slideBounds.right <= bounds.right + 1;
        slide.toggleAttribute('inert', !isVisible);
        slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      });
    }

    function initMegaMenuSwipers() {
      if (typeof window.Swiper !== 'function') return;

      /* Destroy/disable swipers on mobile for card swiper */
      if (isMobileNav()) {
        document.querySelectorAll('.js-mega-menu-card-swiper').forEach(function(el) {
          if (el.swiper) {
            el.swiper.detachEvents();
            el.swiper.update();
            el.swiper.disable();
            el.removeAttribute('role');
            el.removeAttribute('aria-roledescription');
            el.removeAttribute('aria-label');
            el.querySelectorAll('.swiper-slide').forEach(function(slide) {
              slide.removeAttribute('inert');
              slide.removeAttribute('aria-hidden');
            });
          }
        });
      } else {
        /* Initialize card swipers on desktop */
        document.querySelectorAll('.js-mega-menu-card-swiper').forEach(function(el, index) {
          if (!el.classList.contains('swiper-initialized')) {
            el.classList.add('s' + index);
            var cardSwiper = new Swiper('.js-mega-menu-card-swiper.s' + index, {
              slidesPerView: 2,
              spaceBetween: 0,
              speed: 450,
              touchReleaseOnEdges: true,
              threshold: 8,
              touchRatio: 0.5,
              touchAngle: 75,
              touchMoveStopPropagation: true,
              a11y: {
                containerMessage: 'Menu cards',
                containerRoleDescriptionMessage: 'carousel',
                prevSlideMessage: 'Previous menu cards',
                nextSlideMessage: 'Next menu cards'
              },
              mousewheel: {
                releaseOnEdges: false,
                forceToAxis: true,
                sensitivity: 0.25
              },
              navigation: {
                nextEl: '.js-mega-menu-card-swiper.s' + index + ' .swiper-button-next',
                prevEl: '.js-mega-menu-card-swiper.s' + index + ' .swiper-button-prev'
              },
              breakpoints: {
                800: { slidesPerView: 3 },
                1023: {
                  slidesPerView: 4,
                  touchRatio: 0.75,
                  speed: 350,
                  spaceBetween: 20
                },
                1350: {
                  slidesPerView: 5,
                  touchRatio: 0.75,
                  speed: 350,
                  spaceBetween: 20
                }
              },
              on: {
                init: function(swiper) { syncMegaMenuSwiperAccessibility(swiper, 'Menu cards'); },
                slideChange: function(swiper) { syncMegaMenuSwiperAccessibility(swiper, 'Menu cards'); },
                transitionEnd: function(swiper) { syncMegaMenuSwiperAccessibility(swiper, 'Menu cards'); },
                resize: function(swiper) { syncMegaMenuSwiperAccessibility(swiper, 'Menu cards'); }
              }
            });
          }
        });
      }
      
      /* Initialize products swipers */
      document.querySelectorAll('.js-mega-menu-products-swiper').forEach(function(el, index) {
        if (!el.classList.contains('swiper-initialized')) {
          el.classList.add('s' + index);
          var productSwiper = new Swiper('.js-mega-menu-products-swiper.s' + index, {
            slidesPerView: 3,
            spaceBetween: 10,
            speed: 450,
            touchReleaseOnEdges: true,
            threshold: 8,
            touchRatio: 0.5,
            touchAngle: 75,
            touchMoveStopPropagation: true,
            a11y: {
              containerMessage: 'Menu products',
              containerRoleDescriptionMessage: 'carousel',
              prevSlideMessage: 'Previous products',
              nextSlideMessage: 'Next products'
            },
            mousewheel: {
              releaseOnEdges: false,
              forceToAxis: true,
              sensitivity: 0.25
            },
            navigation: {
              nextEl: '.js-mega-menu-products-swiper.s' + index + ' ~ .swiper-button-next',
              prevEl: '.js-mega-menu-products-swiper.s' + index + ' ~ .swiper-button-prev'
            },
            breakpoints: {
              676: { slidesPerView: 5, spaceBetween: 15 },
              1050: {
                slidesPerView: 6,
                touchRatio: 0.75,
                speed: 350
              },
              1200: { slidesPerView: 7 },
              1350: { slidesPerView: 8 }
            },
            on: {
              init: function(swiper) { syncMegaMenuSwiperAccessibility(swiper, 'Menu products'); },
              slideChange: function(swiper) { syncMegaMenuSwiperAccessibility(swiper, 'Menu products'); },
              transitionEnd: function(swiper) { syncMegaMenuSwiperAccessibility(swiper, 'Menu products'); },
              resize: function(swiper) { syncMegaMenuSwiperAccessibility(swiper, 'Menu products'); }
            }
          });
          syncMegaMenuSwiperAccessibility(productSwiper, 'Menu products');
        }
      });
    }

    function requestMegaMenuSwiperInit() {
      if (megaMenuSwiperInitRequested) return;

      megaMenuSwiperInitRequested = true;
      whenSwiperReady(function() {
        window.requestAnimationFrame(function() {
          initMegaMenuSwipers();

          if (!megaMenuSwiperResizeBound) {
            window.addEventListener('resize', initMegaMenuSwipers);
            megaMenuSwiperResizeBound = true;
          }
        });
      });
    }
    
    /* ========================================
       MEGA MENU HOVER/CLICK HANDLERS
       data-main-handle & data-mega-menu
       Touch-friendly: click to open, stays open until click outside
       Non-touch: hover opens menu, click navigates to link
       ======================================== */
    var mainHandles = document.querySelectorAll('[data-main-handle]');
    var megaMenuPanels = document.querySelectorAll('[data-mega-menu]');
    var megaMenuCloseTimeout = null;
    var currentActiveMegaMenu = null;
    var currentActiveTrigger = null;
    var megaMenuOpenedByClick = false; /* Track if menu was opened via click/touch */
    var megaMenuPositionFrame = null;

    function positionMegaMenuListsWrapper() {
      if (!currentActiveMegaMenu || isMobileNav()) return;

      var listsWrapper = currentActiveMegaMenu.querySelector('.mega-menu-desktop-lists-wrapper');
      var layoutContainer = currentActiveMegaMenu.querySelector('.mega-menu-desktop-layout');
      if (!listsWrapper || !layoutContainer || !currentActiveTrigger) return;

      listsWrapper.style.marginLeft = '';

      var triggerLabel = currentActiveTrigger.previousElementSibling;
      if (triggerLabel) triggerLabel = triggerLabel.querySelector('span');

      var triggerRect = (triggerLabel || currentActiveTrigger).getBoundingClientRect();
      var wrapperRect = listsWrapper.getBoundingClientRect();
      var layoutRect = layoutContainer.getBoundingClientRect();
      var maxRight = layoutRect.right;
      var blocksContainer = currentActiveMegaMenu.querySelector('.mega-menu-desktop-blocks');
      var firstBlock = blocksContainer && blocksContainer.firstElementChild;

      if (firstBlock) {
        var rem = parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16;
        maxRight = firstBlock.getBoundingClientRect().left - (2 * rem);
      }

      var offset = triggerRect.left - wrapperRect.left;
      var maxOffset = maxRight - wrapperRect.right;
      listsWrapper.style.marginLeft = Math.max(0, Math.min(offset, maxOffset)) + 'px';
    }

    function scheduleMegaMenuPosition() {
      if (megaMenuPositionFrame) return;

      megaMenuPositionFrame = window.requestAnimationFrame(function() {
        megaMenuPositionFrame = null;
        positionMegaMenuListsWrapper();
      });
    }

    var megaMenuHeader = document.querySelector('#js-header');
    if (megaMenuHeader && 'ResizeObserver' in window) {
      new ResizeObserver(scheduleMegaMenuPosition).observe(megaMenuHeader);
    }
    
    /* Function to close mega menu (used for delayed close and immediate close) */
    function closeMegaMenu(returnFocus) {
      var triggerToFocus = currentActiveTrigger;
      document.body.classList.remove('mega-menu-open');
      megaMenuPanels.forEach(function(panel) {
        panel.classList.remove('active');
        panel.hidden = true;
        var listsWrapper = panel.querySelector('.mega-menu-desktop-lists-wrapper');
        if (listsWrapper) listsWrapper.style.marginLeft = '';
      });
      mainHandles.forEach(function(trigger) {
        trigger.classList.remove('active');
        trigger.setAttribute('aria-expanded', 'false');
        syncMegaMenuTriggerLabel(trigger, false);
      });
      currentActiveMegaMenu = null;
      currentActiveTrigger = null;
      megaMenuOpenedByClick = false;
      if (returnFocus && triggerToFocus) {
        triggerToFocus.focus();
      }
    }

    /* ========================================
       MEGA PANEL SPECULATION
       An opened panel is a strong declaration of browsing intent, and the seconds
       spent reading it are enough head start to absorb an uncached origin render, so
       every destination it offers is prefetched at once — one rule per panel, never
       cancelled, since removing a completed speculation only discards it.

       Panel links are `hidden` until the panel opens, so the document rules in
       snippets/navigation-speculation.liquid cannot reach them by hover or viewport.
       Its route guards are mirrored here; both emitters have to agree.
       ======================================== */
    var speculativelyPrefetchedPanels = new WeakSet();
    var blockedSpeculationPath = /^\/(cart|checkout|checkouts|account|orders|gift_cards|search|challenge|password|apps|a|tools|admin|discount)(\/|$)/;
    var customerRoutePath = /(^|\/)account(\/|$)/;

    function prefetchMegaMenuDestinations(panel) {
      if (customerRoutePath.test(window.location.pathname)) return;
      if (speculativelyPrefetchedPanels.has(panel)) return;
      speculativelyPrefetchedPanels.add(panel);

      var connection = navigator.connection;
      if (connection && (connection.saveData || (connection.effectiveType || '').indexOf('2g') !== -1)) return;
      if (typeof HTMLScriptElement.supports !== 'function' || !HTMLScriptElement.supports('speculationrules')) return;

      var seen = Object.create(null);
      var urls = [];
      Array.prototype.forEach.call(panel.querySelectorAll('a[href]:not([target])'), function(link) {
        var url;
        try {
          url = new URL(link.href, window.location.href);
        } catch (error) {
          return;
        }
        if (url.origin !== window.location.origin) return;
        if (url.hash) return;
        if (url.pathname === window.location.pathname) return;
        if (blockedSpeculationPath.test(url.pathname)) return;
        if (seen[url.href]) return;
        seen[url.href] = true;
        urls.push(url.href);
      });
      if (!urls.length) return;

      var rule = document.createElement('script');
      rule.type = 'speculationrules';
      rule.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls: urls, eagerness: 'immediate' }] });
      document.head.appendChild(rule);
    }

    function openMegaMenu(trigger, openedByClick) {
      var handle = trigger.getAttribute('data-main-handle');
      var megaMenu = document.querySelector('[data-mega-menu="' + handle + '"]');

      if (!megaMenu) return;

      cancelMegaMenuCloseTimeout();
      megaMenuPanels.forEach(function(panel) {
        var isActive = panel === megaMenu;
        panel.classList.toggle('active', isActive);
        panel.hidden = !isActive;
      });
      mainHandles.forEach(function(menuTrigger) {
        var isActive = menuTrigger === trigger;
        menuTrigger.classList.toggle('active', isActive);
        menuTrigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        syncMegaMenuTriggerLabel(menuTrigger, isActive);
      });
      document.body.classList.add('mega-menu-open');
      currentActiveMegaMenu = megaMenu;
      currentActiveTrigger = trigger;
      megaMenuOpenedByClick = openedByClick;
      scheduleMegaMenuPosition();
      prefetchMegaMenuDestinations(megaMenu);
    }

    /* Function to cancel any pending close timeout */
    function cancelMegaMenuCloseTimeout() {
      if (megaMenuCloseTimeout) {
        clearTimeout(megaMenuCloseTimeout);
        megaMenuCloseTimeout = null;
      }
    }

    function syncMegaMenuTriggerLabel(trigger, isOpen) {
      var label = trigger.getAttribute(isOpen ? 'data-mega-menu-close-label' : 'data-mega-menu-open-label');
      if (label) {
        trigger.setAttribute('aria-label', label);
      }
    }
    
    /* Function to immediately close mega menu (for search/cart clicks) */
    function immediateCloseMegaMenu(returnFocus) {
      cancelMegaMenuCloseTimeout();
      closeMegaMenu(returnFocus);
    }
    
    /* Handle click on mega menu triggers (touch-friendly) */
    function handleMegaMenuClick(e) {
      /* Only handle clicks directly on the trigger element, not on other elements inside the li */
      var clickedTrigger = e.target.closest('[data-main-handle]');
      if (!clickedTrigger) return;
      
      var handle = clickedTrigger.getAttribute('data-main-handle');
      var megaMenu = document.querySelector('[data-mega-menu="' + handle + '"]');
      
      if (!megaMenu) return;
      
      e.preventDefault();
      if (currentActiveMegaMenu === megaMenu && megaMenu.classList.contains('active')) {
        if (!megaMenuOpenedByClick) {
          megaMenuOpenedByClick = true;
        } else {
          closeMegaMenu();
        }
        return;
      }
      requestMegaMenuSwiperInit();
      openMegaMenu(clickedTrigger, true);
    }
    
    /* Handle hover interactions (for mouse users) */
    function handleMegaMenuHover(e) {
      var trigger = this.querySelector('[data-main-handle]');
      if (!trigger) return;
      
      var handle = trigger.getAttribute('data-main-handle');
      var megaMenu = document.querySelector('[data-mega-menu="' + handle + '"]');
      
      /* Skip hover behavior if menu was opened by click */
      if (megaMenuOpenedByClick) return;
      
      if (!megaMenu) return;
      
      if (e.type === 'mouseenter') {
        /* Cancel any pending close */
        cancelMegaMenuCloseTimeout();
        requestMegaMenuSwiperInit();
        
        openMegaMenu(trigger, false);
      } else if (e.type === 'mouseleave') {
        /* Cancel any existing timeout before scheduling a new one
           This prevents orphaned timeouts from firing unexpectedly */
        cancelMegaMenuCloseTimeout();
        
        /* Delay before closing (allows moving to mega menu panel) */
        megaMenuCloseTimeout = setTimeout(function() {
          closeMegaMenu();
        }, 300);
      }
    }
    
    /* Mobile click handler (original behavior) */
    function handleMobileMegaMenuClick(e) {
      /* Only handle clicks directly on the trigger element */
      var clickedTrigger = e.target.closest('[data-main-handle]');
      if (!clickedTrigger) return;
      
      var handle = clickedTrigger.getAttribute('data-main-handle');
      var megaMenu = document.querySelector('[data-mega-menu="' + handle + '"]');
      
      if (!megaMenu) return;
      requestMegaMenuSwiperInit();
      
      openMegaMenu(clickedTrigger, true);
    }

    function handleMegaMenuFocusOut(e) {
      if (isMobileNav()) return;
      if (!this.contains(e.relatedTarget)) {
        closeMegaMenu();
      }
    }
    
    function setupMegaMenuListeners() {
      mainHandles.forEach(function(handle) {
        var li = handle.closest('li');
        if (!li) return;
        
        /* Remove all existing listeners first */
        li.removeEventListener('mouseenter', handleMegaMenuHover, false);
        li.removeEventListener('mouseleave', handleMegaMenuHover, false);
        li.removeEventListener('click', handleMegaMenuClick, false);
        li.removeEventListener('click', handleMobileMegaMenuClick, false);
        li.removeEventListener('focusout', handleMegaMenuFocusOut, false);
        
        if (!isMobileNav()) {
          /* Desktop: both hover (for mouse) and click (for touch) */
          li.addEventListener('mouseenter', handleMegaMenuHover, false);
          li.addEventListener('mouseleave', handleMegaMenuHover, false);
          li.addEventListener('click', handleMegaMenuClick, false);
          li.addEventListener('focusout', handleMegaMenuFocusOut, false);
        } else {
          /* Mobile: click only */
          li.addEventListener('click', handleMobileMegaMenuClick, false);
        }
      });
    }
    
    /* Initial setup */
    if (megaMenuPanels && megaMenuPanels.length) {
      setupMegaMenuListeners();
      
      /* Desktop: Keep mega menu open when hovering over the panel itself */
      megaMenuPanels.forEach(function(panel) {
        panel.addEventListener('mouseenter', function() {
          if (!isMobileNav()) {
            cancelMegaMenuCloseTimeout();
          }
        });
        panel.addEventListener('mouseleave', function() {
          if (!isMobileNav() && !megaMenuOpenedByClick) {
            /* Cancel any existing timeout before scheduling a new one
               This prevents orphaned timeouts from firing unexpectedly */
            cancelMegaMenuCloseTimeout();
            
            /* Only auto-close on hover leave if not opened by click */
            megaMenuCloseTimeout = setTimeout(function() {
              closeMegaMenu();
            }, 300);
          }
        });
      });
    }
    
    window.addEventListener('resize', function() {
      closeMegaMenu(); /* Close menu on resize */
      setupMegaMenuListeners();
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && currentActiveMegaMenu) {
        event.preventDefault();
        immediateCloseMegaMenu(true);
      }
    });
    
    /* ========================================
       CLOSE MEGA MENU ON OUTSIDE CLICK
       Desktop only - mobile has its own close behavior
       ======================================== */
    document.addEventListener('click', function(event) {
      /* Only run on desktop */
      if (isMobileNav()) return;
      if (!document.body.classList.contains('mega-menu-open')) return;
      
      /* Don't close if clicking inside the mega menu panel */
      if (event.target.closest('.mega-menu[data-mega-menu]')) return;
      /* Don't close if clicking on a trigger (handled by trigger click handler) */
      if (event.target.closest('[data-main-handle]')) return;
      /* Don't close if clicking the hamburger toggle */
      if (event.target.closest('.js-toggle-nav')) return;
      
      /* Close the mega menu */
      closeMegaMenu();
    });
    
    /* ========================================
       MEGA MENU STYLE OBSERVER (DESKTOP)
       ======================================== */
    var targetNode = document.querySelector('.mega-menu');
    if (targetNode) {
      var styleObserver = new MutationObserver(function(muts) {
        muts.forEach(function(m) {
          if (m.type === 'attributes' && m.attributeName === 'style') {
            if (targetNode.style.position === 'relative') {
              targetNode.style.position = '';
              targetNode.style.top = '';
              targetNode.style.cssText = 'z-index: 0 !important';
            }
          }
        });
      });
      styleObserver.observe(targetNode, { attributes: true });
    }
    
    /* ========================================
       MOBILE MENU DISCLOSURE ANIMATION
       ======================================== */
    function setMobileMenuDetailsState(detailsEl, isOpen) {
      var panel = detailsEl.querySelector('.mobile-submenu');
      var toggle = detailsEl.querySelector('.mobile-menu__toggle');
      var arrow = detailsEl.querySelector('.arrow');
      if (!panel || !toggle) return;

      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (isOpen) {
        panel.hidden = false;
        panel.style.maxHeight = '0';
        var h = panel.scrollHeight;
        requestAnimationFrame(function() {
          panel.style.maxHeight = h + 'px';
        });
        if (arrow) arrow.textContent = '-';
      } else {
        var height = panel.scrollHeight;
        panel.style.maxHeight = height + 'px';
        requestAnimationFrame(function() {
          panel.style.maxHeight = '0';
        });
        if (arrow) arrow.textContent = '+';
      }
    }

    document.querySelectorAll('.mobile-menu__details').forEach(function(detailsEl) {
      var panel = detailsEl.querySelector('.mobile-submenu');
      var toggle = detailsEl.querySelector('.mobile-menu__toggle');
      if (!panel || !toggle) return;

      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }

      toggle.addEventListener('click', function() {
        setMobileMenuDetailsState(detailsEl, toggle.getAttribute('aria-expanded') !== 'true');
      });

      panel.addEventListener('transitionend', function(event) {
        if (event.propertyName === 'max-height' && toggle.getAttribute('aria-expanded') === 'false') {
          panel.hidden = true;
        }
      });
    });
    
    /* ========================================
       INITIAL STATE CLEANUP
       ======================================== */
    document.body.classList.remove('mega-menu-open');
    document.body.classList.remove('search-open');
    
    /* Set header data attribute */
    var header = document.querySelector('#js-header');
    if (header) {
      header.setAttribute('data-active-color', 'black');
    }
    
    /* Set body class based on page */
    var pathSegment = location.pathname.split('/')[1];
    var pathLower = pathSegment ? pathSegment.toLowerCase() : '';
    
    if (pathSegment === '' || pathSegment === 'index.php') {
      document.body.classList.add('home');
    } else if (pathLower) {
      document.body.classList.add(pathLower);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-text-block"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
  var firstH1 = document.querySelector('h1');
  var richTextBlocks = document.querySelectorAll('.rich-text');

  richTextBlocks.forEach(function(block) {
    var h1Tags = block.querySelectorAll('h1');

    h1Tags.forEach(function(tag) {
      if (tag === firstH1) {
        return;
      }
      var newH2 = document.createElement('h2');
      newH2.innerHTML = tag.innerHTML;
      newH2.classList.add('heading-xl');
      tag.parentNode.replaceChild(newH2, tag);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-text-overlay"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-media-text-overlay-pause]').forEach(function (button) {
    var video = document.getElementById(button.getAttribute('aria-controls'));
    if (!video) return;

    function updateButton() {
      button.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
      button.setAttribute('data-paused', video.paused ? 'true' : 'false');
    }

    button.addEventListener('click', function () {
      if (video.paused) {
        video.play().catch(updateButton);
      } else {
        video.pause();
      }
    });

    video.addEventListener('pause', updateButton);
    video.addEventListener('play', updateButton);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.pause();
    }

    updateButton();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-text"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-media-text-autoplay]').forEach(function (wrapper) {
    var video = wrapper.querySelector('video');
    if (!video) return;

    var button = wrapper.querySelector('[data-media-text-video-pause]');

    function updateButton() {
      if (!button) return;
      var isPaused = video.paused;
      button.setAttribute('aria-label', isPaused ? 'Play video' : 'Pause video');
      button.setAttribute('data-paused', isPaused ? 'true' : 'false');
    }

    function pauseForReducedMotion() {
      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.pause();
      updateButton();
    }

    if (button) {
      button.addEventListener('click', function () {
        if (video.paused) {
          video.play().catch(updateButton);
        } else {
          video.pause();
        }
      });
    }

    video.addEventListener('pause', updateButton);
    video.addEventListener('play', updateButton);

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reducedMotion.matches) {
      pauseForReducedMotion();
    } else {
      updateButton();
    }

    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', function (event) {
        if (event.matches) pauseForReducedMotion();
      });
    } else if (reducedMotion.addListener) {
      reducedMotion.addListener(function (event) {
        if (event.matches) pauseForReducedMotion();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-before-after"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var quotesSwiperElements = document.querySelectorAll('.b-a-stats_swiper');

    quotesSwiperElements.forEach(function(element) {
      var previousButton = element.parentElement.querySelector('.js-before-after-previous');
      var nextButton = element.parentElement.querySelector('.js-before-after-next');
      var controls = element.parentElement.querySelector('.b-a-stats_controls');

      var swiper = new Swiper(element, {
        slidesPerView: "auto",
        slidesPerGroupAuto: false,
        speed: 400,
        cssMode: false,
        spaceBetween: 20,
        loop: false,
        passiveListeners: true,
        watchSlidesProgress: true,
        centeredSlides: false,
        shortSwipes: true,
        threshold: 20,
        touchAngle: 75,
        touchMoveStopPropagation: true,
        mousewheel: {
          releaseOnEdges: false,
          forceToAxis: true,
          sensitivity: 0.5,
        },
        pagination: {
          el: element.querySelector('.swiper-pagination'),
          clickable: true,
          renderBullet: function(index, className) {
            return '<button type="button" class="' + className + '" aria-label="Show before and after result ' + (index + 1) + '" aria-pressed="false" data-click-name="PDP Before and After - Result"></button>';
          },
        },
        breakpoints: {
          479: {
            slidesPerView: "auto",
            loop: false,
            centeredSlides: false,
            spaceBetween: 0,
          }
        },
      });

      var updateControls = function() {
        var hasMultipleSlides = swiper.slides.length > 1 && !swiper.isLocked && !(swiper.isBeginning && swiper.isEnd);
        var carouselBounds = swiper.el.getBoundingClientRect();

        controls.hidden = !hasMultipleSlides;
        previousButton.setAttribute('aria-disabled', String(swiper.isBeginning));
        nextButton.setAttribute('aria-disabled', String(swiper.isEnd));

        element.querySelectorAll('.swiper-pagination-bullet').forEach(function(bullet) {
          bullet.setAttribute('aria-pressed', String(bullet.classList.contains('swiper-pagination-bullet-active')));
        });

        swiper.slides.forEach(function(slide) {
          var slideBounds = slide.getBoundingClientRect();
          var isVisible = slide.classList.contains('swiper-slide-visible')
            && slideBounds.left >= carouselBounds.left - 1
            && slideBounds.right <= carouselBounds.right + 1;

          slide.toggleAttribute('inert', !isVisible);
          slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
        });
      };

      previousButton.addEventListener('click', function() {
        if (previousButton.getAttribute('aria-disabled') !== 'true') swiper.slidePrev();
      });

      nextButton.addEventListener('click', function() {
        if (nextButton.getAttribute('aria-disabled') !== 'true') swiper.slideNext();
      });

      ['init', 'slideChange', 'transitionEnd', 'resize', 'update', 'lock', 'unlock'].forEach(function(eventName) {
        swiper.on(eventName, updateControls);
      });

      updateControls();


    /* YOTPO FUNCTIONS */
    function elementFound() {
        /* Find the first .yotpo-head and .yotpo-layout-header-wrapper elements on the page */
        const yotpoHead = document.querySelector('.yotpo-head');
        const yotpoLayoutHeaderWrapper = document.querySelector('.yotpo-layout-header-wrapper');
        
        /* Move the .yotpo-head element inside the .yotpo-layout-header-wrapper element as the first item */
        if (yotpoHead && yotpoLayoutHeaderWrapper) {
          yotpoLayoutHeaderWrapper.insertBefore(yotpoHead, yotpoLayoutHeaderWrapper.firstChild);
        }
      }
      
      function checkForElement() {
        const yotpoHead = document.querySelector('.yotpo-head');
        if (yotpoHead) {
          elementFound();
          clearInterval(intervalID);
        }
      }
      const intervalID = setInterval(checkForElement, 100);


    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quotes"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var quotesSwiperElements = document.querySelectorAll('.quotes_swiper');

    quotesSwiperElements.forEach(function(element) {
      var layout = element.closest('.quotes_layout');
      var swiper = new Swiper(element, {
        slidesPerView: 1,
        speed: 400,
        cssMode: false,
        spaceBetween: 0,
        loop: true,
        passiveListeners: true,
        centeredSlides: true,
        shortSwipes: true,
        threshold: 20,
        watchSlidesProgress: true,
        touchAngle: 75,
        touchMoveStopPropagation: true,
        a11y: {
          containerRoleDescriptionMessage: 'carousel',
          itemRoleDescriptionMessage: 'slide',
          slideRole: 'listitem',
          slideLabelMessage: 'Quote \u007b\u007bindex\u007d\u007d of \u007b\u007bslidesLength\u007d\u007d',
          prevSlideMessage: 'Previous quote',
          nextSlideMessage: 'Next quote',
        },
        mousewheel: {
          releaseOnEdges: false,
          forceToAxis: true,
          sensitivity: 0.5,
        },
        navigation: {
          nextEl: layout.querySelector('.swiper-button-next'),
          prevEl: layout.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          991: {
            slidesPerView: 3,
            centeredSlides: true,
          }
        },
        on: {
          init: function() {
            syncSlides(this);
          },
          slideChange: function() {
            syncSlides(this);
          },
          slideChangeTransitionEnd: function() {
            syncSlides(this);
          },
          update: function() {
            syncSlides(this);
          },
          resize: function() {
            syncSlides(this);
          }
        }
      });

      function syncSlides(instance) {
        var visibleSlides = instance.visibleSlides && instance.visibleSlides.length
          ? Array.prototype.slice.call(instance.visibleSlides)
          : Array.prototype.filter.call(instance.slides, function(slide) {
              return slide.classList.contains('swiper-slide-visible');
            });

        if (!visibleSlides.length) {
          var visibleCount = Number(instance.params.slidesPerView) || 1;
          var startIndex = instance.activeIndex;

          if (visibleCount > 1) {
            startIndex -= Math.floor((visibleCount - 1) / 2);
          }

          visibleSlides = Array.prototype.slice.call(instance.slides, startIndex, startIndex + visibleCount);
        }

        Array.prototype.forEach.call(instance.slides, function(slide) {
          var hidden = visibleSlides.indexOf(slide) === -1;

          slide.toggleAttribute('inert', hidden);
          slide.setAttribute('aria-hidden', hidden ? 'true' : 'false');
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
/* Add any JavaScript specific to this section here. */

  } catch(e) { console.error(e); }
})();
})();
